import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import { Grid, Typography, Button, ListItemButton, ListItemIcon, Checkbox, ListItemText, Tooltip, Box, useTheme, DialogTitle, Dialog, DialogContent, DialogActions, FormControl, FormLabel, OutlinedInput, FormHelperText, debounce as debounce$1, InputAdornment, Autocomplete, TextField, CircularProgress, MenuItem, Select, Paper, styled, Card, CardActions, IconButton, Collapse, CardHeader, Stack, CardContent, Backdrop, Breadcrumbs, Link, FormControlLabel, Switch, Menu, Chip, Divider, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, TableFooter, TableSortLabel, TablePagination, Toolbar, Fab, Avatar } from '@mui/material';
import * as React from 'react';
import React__default, { createContext, useContext, useCallback, useMemo, useState, useEffect, createElement, forwardRef, useRef } from 'react';
import { DragHandle, InfoOutlined, ArrowLeft, ArrowRight, Warning, ExpandMore, Close, NavigateNext, Edit, Check, Save, Delete, Cancel, MoreVert, Search, Unarchive, Archive, AddCircle, SortByAlpha, FilterList, UploadFile, FirstPage, KeyboardArrowLeft, KeyboardArrowRight, LastPage, Visibility, RestoreFromTrash, AutoAwesome } from '@mui/icons-material';
import _, { debounce } from 'lodash';
import 'papaparse';
import { SnackbarContent, useSnackbar } from 'notistack';
import { useNavigate } from 'react-router';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

var ApiError = function (props) {
    var onReloadClick = props.onReloadClick;
    return (jsxs(Grid, __assign({ container: true, direction: "column", alignItems: "center" }, { children: [jsx(Grid, __assign({ item: true }, { children: jsx(Typography, { children: "There was an error while loading. Click the button below to retry." }, void 0) }), void 0),
            jsx(Grid, __assign({ item: true }, { children: jsx(Button, __assign({ variant: "contained", onClick: onReloadClick }, { children: "Reload" }), void 0) }), void 0)] }), void 0));
};

var userHasPermissions = function (authPermissions, permissions, logic) {
    logic = logic ? logic : 'and';
    switch (logic) {
        case "and":
            return userHasAllPermissions(authPermissions, permissions);
        case "or":
            return userHasAnyPermissions(authPermissions, permissions);
        default:
            throw new Error("Unknown logical operator [" + logic + "] for comparing permissions.");
    }
};
var userHasAllPermissions = function (expectedPermissions, userPermissions) {
    if (expectedPermissions.length === 0)
        return true;
    if (userPermissions.length === 0)
        return false;
    for (var _i = 0, expectedPermissions_1 = expectedPermissions; _i < expectedPermissions_1.length; _i++) {
        var expectedPermission = expectedPermissions_1[_i];
        if (!userPermissions.includes(expectedPermission)) {
            return false;
        }
    }
    return true;
};
var userHasAnyPermissions = function (expectedPermissions, userPermissions) {
    if (expectedPermissions.length === 0)
        return true;
    if (userPermissions.length === 0)
        return false;
    for (var _i = 0, expectedPermissions_2 = expectedPermissions; _i < expectedPermissions_2.length; _i++) {
        var expectedPermission = expectedPermissions_2[_i];
        if (userPermissions.includes(expectedPermission)) {
            return true;
        }
    }
    return false;
};

var UserPermissionContext = createContext({
    permissions: [],
    togglePermission: function (permission) { },
    clearPermissions: function () { }
});

var AuthenticatedComponent = function (props) {
    var requiredPermissions = props.requiredPermissions, _a = props.logic, logic = _a === void 0 ? 'and' : _a, children = props.children;
    var permissions = useContext(UserPermissionContext).permissions;
    var isUserAllowedToView = userHasPermissions(requiredPermissions, permissions, logic);
    return isUserAllowedToView ? jsx(Fragment, { children: children }, void 0) : jsx(Fragment, {}, void 0);
};

var TransferListItem = function (_a) {
    var onClick = _a.onClick, listItem = _a.listItem, isSelected = _a.isSelected, orderable = _a.orderable, handleReorderRequest = _a.handleReorderRequest;
    var handleItemClicked = useCallback(function () {
        onClick(listItem);
    }, [onClick, listItem]);
    var handleOnDragStart = useCallback(function (e) {
        e.dataTransfer.dropEffect = 'move';
        e.dataTransfer.setData('text/plain', listItem.value);
    }, [listItem.value]);
    var handleOnDragOver = useCallback(function (e) {
        e.preventDefault();
        e.dataTransfer.dropEffect = 'move';
    }, []);
    var handleOnDrop = useCallback(function (e) {
        e.preventDefault();
        var coords = e.currentTarget.getBoundingClientRect();
        var dragLocation = e.clientY - coords.y > coords.height / 2 ? 'below' : 'above';
        handleReorderRequest(e.dataTransfer.getData('text/plain'), listItem.value, dragLocation);
    }, [handleReorderRequest, listItem.value]);
    return (jsxs(ListItemButton, __assign({ role: 'listitem', onClick: handleItemClicked, disableRipple: true, draggable: true, onDragStart: handleOnDragStart, onDragOver: handleOnDragOver, onDrop: handleOnDrop }, { children: [jsxs(ListItemIcon, __assign({ sx: { display: 'flex', alignItems: 'center' } }, { children: [orderable && jsx(DragHandle, {}, void 0),
                    jsx(Checkbox, { checked: isSelected, disableRipple: true }, void 0)] }), void 0),
            jsx(ListItemText, { id: listItem.value, primary: listItem.label, sx: { pointerEvents: 'none' } }, void 0),
            listItem.description && (jsx(Tooltip, __assign({ title: listItem.description }, { children: jsx(InfoOutlined, {}, void 0) }), void 0))] }), void 0));
};

var TransferListColumn = function (props) {
    var columnLabel = props.columnLabel, options = props.options, selectedOptions = props.selectedOptions, onSelectedItemsChange = props.onSelectedItemsChange, orderable = props.orderable, handleReorderRequest = props.handleReorderRequest;
    var toggleOption = useCallback(function (option) {
        var isCurrentlySelected = selectedOptions.some(function (o) { return o.value === option.value; });
        var updatedSelectedOptions = _.cloneDeep(selectedOptions);
        if (isCurrentlySelected) {
            updatedSelectedOptions = updatedSelectedOptions.filter(function (o) { return o.value !== option.value; });
        }
        else {
            updatedSelectedOptions.push(option);
        }
        onSelectedItemsChange(updatedSelectedOptions);
    }, [selectedOptions, onSelectedItemsChange]);
    var renderListItems = useMemo(function () {
        return options.map(function (option) { return jsx(TransferListItem, { listItem: option, onClick: toggleOption, isSelected: selectedOptions.some(function (o) { return o.value === option.value; }), orderable: orderable, handleReorderRequest: handleReorderRequest }, void 0); });
    }, [options, selectedOptions, toggleOption, orderable, handleReorderRequest]);
    return (jsxs(Grid, __assign({ item: true, flexGrow: 1, border: '1px solid #AAAAAA', borderRadius: 1, height: '100%', overflow: 'hidden' }, { children: [jsx(Box, __assign({ width: '100%', textAlign: 'center', borderBottom: '1px solid #AAAAAA' }, { children: jsx(Typography, { children: columnLabel }, void 0) }), void 0),
            jsx(Box, __assign({ height: 'calc(100% - 24px)', overflow: 'auto' }, { children: renderListItems }), void 0)] }), void 0));
};

var BasicTransferList = function (props) {
    var _a = props.targetColumnName, targetColumnName = _a === void 0 ? 'Selected' : _a, _b = props.sourceColumnName, sourceColumnName = _b === void 0 ? 'Available' : _b, currentItems = props.currentItems, allItems = props.allItems, onCurrentItemsChanged = props.onCurrentItemsChanged, _c = props.height, height = _c === void 0 ? 200 : _c, _d = props.orderable, orderable = _d === void 0 ? false : _d;
    var availableItems = useMemo(function () { return _.differenceBy(allItems, currentItems, 'value'); }, [currentItems, allItems]);
    var _e = useState([]), selectedCurrentItems = _e[0], setSelectedCurrentItems = _e[1];
    var _f = useState([]), selectedAvailableItems = _f[0], setSelectedAvailableItems = _f[1];
    var onAddClicked = useCallback(function () {
        onCurrentItemsChanged(_.uniqBy(__spreadArrays(currentItems, selectedAvailableItems), 'value'));
        setSelectedCurrentItems([]);
    }, [currentItems, selectedAvailableItems, onCurrentItemsChanged]);
    var onRemoveClicked = useCallback(function () {
        var selectedItemValues = selectedCurrentItems.map(function (item) { return item.value; });
        var updatedCurrentItems = currentItems.filter(function (item) { return !selectedItemValues.includes(item.value); });
        onCurrentItemsChanged(updatedCurrentItems);
        setSelectedAvailableItems([]);
    }, [selectedCurrentItems, currentItems, onCurrentItemsChanged]);
    var handleReorderRequest = useCallback(function (sourceItem, targetItem, aboveOrBelow) {
        var sourceItemIndex = currentItems.findIndex(function (x) { return x.value === sourceItem; });
        var targetItemIndex = currentItems.findIndex(function (x) { return x.value === targetItem; });
        if (sourceItemIndex === -1 || targetItemIndex === -1) {
            console.error('Unable to reorder transfer list items because the original indexes could not be found');
            return;
        }
        console.log('sourceItem: ', sourceItem);
        console.log('targetItem: ', targetItem);
        if (sourceItemIndex === targetItemIndex) {
            console.info('Attempted to move transfer list item to the same location it already is. Request ignored.');
            return;
        }
        var updatedCurrentItems = _.cloneDeep(currentItems);
        var itemToMove = updatedCurrentItems.splice(sourceItemIndex, 1)[0];
        var indexOffset = sourceItemIndex < targetItemIndex ? -1 : 0;
        indexOffset = aboveOrBelow === 'above' ? indexOffset : indexOffset + 1;
        var adjustedTargetIndex = targetItemIndex + indexOffset;
        updatedCurrentItems.splice(adjustedTargetIndex, 0, itemToMove);
        onCurrentItemsChanged(updatedCurrentItems);
    }, [currentItems, onCurrentItemsChanged]);
    return (jsxs(Grid, __assign({ container: true, direction: 'row', alignItems: 'stretch', height: height }, { children: [jsx(TransferListColumn, { columnLabel: targetColumnName, options: currentItems, selectedOptions: selectedCurrentItems, onSelectedItemsChange: setSelectedCurrentItems, orderable: orderable, handleReorderRequest: handleReorderRequest }, void 0),
            jsxs(Grid, __assign({ item: true, width: 80, display: 'flex', justifyContent: 'center', flexDirection: 'column', p: 1, gap: 1 }, { children: [jsx(Button, __assign({ variant: 'outlined', onClick: onAddClicked }, { children: jsx(ArrowLeft, {}, void 0) }), void 0),
                    jsx(Button, __assign({ variant: 'outlined', onClick: onRemoveClicked }, { children: jsx(ArrowRight, {}, void 0) }), void 0)] }), void 0),
            jsx(TransferListColumn, { columnLabel: sourceColumnName, options: availableItems, selectedOptions: selectedAvailableItems, onSelectedItemsChange: setSelectedAvailableItems, 
                // TODO: we don't want this right list to be orderable so the quick solution for that is to do this but we should really make this a different component or make the properties optional
                orderable: false, handleReorderRequest: function () { } }, void 0)] }), void 0));
};

var StandardDialogHeader = function (props) {
    var icon = props.icon, text = props.text;
    var theme = useTheme();
    return (jsx(DialogTitle, __assign({ sx: { backgroundColor: theme.palette.primary.main, color: theme.palette.primary.contrastText, fontWeight: 'bold' } }, { children: jsxs(Grid, __assign({ container: true, direction: 'row', alignItems: 'center', gap: 1 }, { children: [icon, jsx(Typography, __assign({ fontSize: 'inherit', fontWeight: 'inherit' }, { children: text }), void 0)] }), void 0) }), void 0));
};

var ConfirmationModalWrapper = function (_a) {
    var isOpen = _a.isOpen, title = _a.title, _b = _a.confirmText, confirmText = _b === void 0 ? 'Confirm' : _b, cancel = _a.cancel, confirm = _a.confirm, children = _a.children, icon = _a.icon, _c = _a.maxWidth, maxWidth = _c === void 0 ? 'md' : _c;
    return (jsxs(Dialog, __assign({ open: isOpen, onClose: cancel, fullWidth: true, maxWidth: maxWidth }, { children: [jsx(StandardDialogHeader, { icon: icon || jsx(Warning, {}, void 0), text: title }, void 0),
            jsx(DialogContent, __assign({ sx: { marginTop: 3 } }, { children: children }), void 0),
            jsx(DialogActions, { children: jsxs(Box, __assign({ sx: { display: 'flex', flexDirection: 'row', justifyItems: 'end', gap: 1 } }, { children: [jsx(Button, __assign({ variant: 'outlined', onClick: cancel }, { children: "Cancel" }), void 0),
                        jsx(Button, __assign({ color: 'primary', variant: 'contained', size: 'medium', onClick: confirm }, { children: confirmText }), void 0)] }), void 0) }, void 0)] }), void 0));
};

function isAlphanumericLowercase() {
    return function (value) {
        var errorMessageBuilder = function (fieldName) { return fieldName + " must all be lowercase"; };
        if (value === null || value === undefined) {
            return {
                isValid: true,
                errorMessageBuilder: errorMessageBuilder
            };
        }
        var stringValue = typeof value === 'string' ? value : value.toString();
        var isEmpty = stringValue.trim() === '';
        var isValid = isEmpty || /^[a-z0-9]+$/.test(stringValue);
        return {
            isValid: isValid,
            errorMessageBuilder: errorMessageBuilder,
        };
    };
}

function isAlphanumericUppercase() {
    return function (value) {
        var errorMessageBuilder = function (fieldName) { return fieldName + " must all be uppercase"; };
        if (value === null || value === undefined) {
            return {
                isValid: true,
                errorMessageBuilder: errorMessageBuilder
            };
        }
        var stringValue = typeof value === 'string' ? value : value.toString();
        var isEmpty = stringValue.trim() === '';
        var isValid = isEmpty || /^[A-Z0-9]+$/.test(stringValue);
        return {
            isValid: isValid,
            errorMessageBuilder: errorMessageBuilder,
        };
    };
}

// TODO: add unit tests
function isGreaterThanOrEqualTo(minValue) {
    return function (value) {
        if (!value && value !== 0) {
            return {
                isValid: true,
                errorMessageBuilder: function (_) {
                    return '';
                },
            };
        }
        var parsedValue = Number(value);
        if (Number.isNaN(parsedValue)) {
            return {
                isValid: false,
                errorMessageBuilder: function (fieldName) {
                    return fieldName + " must be a valid number";
                },
            };
        }
        return {
            isValid: parsedValue >= minValue,
            errorMessageBuilder: function (fieldName) {
                return fieldName + " must be greater than or equal to " + minValue;
            },
        };
    };
}

// TODO: add unit tests
function isLowercase() {
    return function (value) {
        var errorMessageBuilder = function (fieldName) { return fieldName + " must all be lowercase"; };
        if (value === null || value === undefined) {
            return {
                isValid: true,
                errorMessageBuilder: errorMessageBuilder
            };
        }
        var stringValue = typeof value === 'string' ? value : value.toString();
        var isValid = /^[a-z]+$/.test(stringValue);
        return {
            isValid: isValid,
            errorMessageBuilder: errorMessageBuilder,
        };
    };
}

var emptyGuid = '00000000-0000-0000-0000-000000000000';

var isEmail = function (value) {
    var regexExp = new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    if (value) {
        return regexExp.test(value) && !value.endsWith('.');
    }
    else {
        return true;
    }
};

var isNotBlank = function (value) {
    var isValid = value !== null && value !== undefined && (typeof value !== 'string' || value.trim() !== '') && value !== emptyGuid && !(Array.isArray(value) && value.length === 0);
    var errorMessageBuilder = function (fieldName) { return fieldName + " is required"; };
    return {
        isValid: isValid,
        errorMessageBuilder: errorMessageBuilder
    };
};

var isOnlyNumbers = function (value) {
    var errorMessageBuilder = function (fieldName) { return fieldName + " may only contain numbers"; };
    if (value === null || value === undefined) {
        return {
            isValid: true,
            errorMessageBuilder: errorMessageBuilder
        };
    }
    var stringValue = typeof value === 'string' ? value : value.toString();
    var isEmpty = stringValue.trim() === '';
    var isValid = isEmpty || /^[0-9]+$/.test(stringValue);
    return {
        isValid: isValid,
        errorMessageBuilder: errorMessageBuilder,
    };
};

// TODO: add unit tests
function isShorterThanMaxLength(maxLength) {
    return function (value) {
        var errorMessageBuilder = function (fieldName) { return fieldName + " must be " + maxLength + " characters or less"; };
        if (value === null || value === undefined) {
            return {
                isValid: true,
                errorMessageBuilder: errorMessageBuilder
            };
        }
        var stringValue = typeof value === 'string' ? value : value.toString();
        var isValid = stringValue.length <= maxLength;
        return {
            isValid: isValid,
            errorMessageBuilder: errorMessageBuilder
        };
    };
}

// TODO: add unit tests
function isUppercase() {
    return function (value) {
        var errorMessageBuilder = function (fieldName) { return fieldName + " must all be uppercase"; };
        if (value === null || value === undefined) {
            return {
                isValid: true,
                errorMessageBuilder: errorMessageBuilder
            };
        }
        var stringValue = typeof value === 'string' ? value : value.toString();
        var isValid = /^[A-Z]+$/.test(stringValue);
        return {
            isValid: isValid,
            errorMessageBuilder: errorMessageBuilder,
        };
    };
}

var errorMessageBuilder = function (fieldName) { return fieldName + " must be a valid email address"; };
// TODO: add unit tests
var isValidEmail = function (value) {
    var hasValue = !!value;
    if (!hasValue) {
        // If there is no email provided we should consider it valid. If the form requires a value then this field should also have the isNotBlank for validator applied.
        return {
            isValid: true,
            errorMessageBuilder: errorMessageBuilder
        };
    }
    var isCorrectType = value !== null && value !== undefined && typeof value === 'string';
    var isValid = isCorrectType && isEmail(value);
    return {
        isValid: isValid,
        errorMessageBuilder: errorMessageBuilder
    };
};

// TODO: add unit tests
function runFieldValidation(fieldValue, validationConfig) {
    var isValid = true;
    var errorMessage = '';
    var validationResults = validationConfig.validators.map(function (validationMethod) { return validationMethod(fieldValue); });
    var failedValidation = validationResults.find(function (result) { return !result.isValid; });
    if (failedValidation) {
        isValid = false;
        errorMessage = failedValidation.errorMessageBuilder(validationConfig.errorMessageEntityName);
    }
    return {
        isValid: isValid,
        errorMessage: errorMessage
    };
}

// TODO: add unit tests
function runFormValidation(formValue, validationConfigs) {
    var isValid = true;
    var errorMessages = new Map();
    validationConfigs.forEach(function (validationConfig, fieldName) {
        var fieldValue = formValue[fieldName];
        var validationResults = validationConfig.validators.map(function (validationMethod) { return validationMethod(fieldValue); });
        var failedValidation = validationResults.find(function (result) { return !result.isValid; });
        if (failedValidation) {
            isValid = false;
            if (!errorMessages.has(fieldName)) {
                var errorMessage = failedValidation.errorMessageBuilder(validationConfig.errorMessageEntityName);
                errorMessages.set(fieldName, errorMessage);
            }
        }
    });
    return {
        isValid: isValid,
        errorMessages: errorMessages
    };
}

var createValidatorConfig = function (validators, errorMessageEntityName) {
    return { validators: validators, errorMessageEntityName: errorMessageEntityName };
};

function isValidURL() {
    return function (value) {
        if (!value) {
            return {
                isValid: true,
                errorMessageBuilder: function () { return ''; },
            };
        }
        var stringValue = typeof value === 'string' ? value : value.toString();
        var isValid;
        try {
            new URL(stringValue);
            isValid = true;
        }
        catch (error) {
            isValid = false;
        }
        var errorMessageBuilder = function (fieldName) { return fieldName + " must be a valid URL"; };
        return {
            isValid: isValid,
            errorMessageBuilder: errorMessageBuilder,
        };
    };
}

var FormInput = React__default.memo(function (props) {
    var disabled = props.disabled, errorText = props.errorText, fullWidth = props.fullWidth, label = props.label, labelFontSize = props.labelFontSize, name = props.name, onBlur = props.onBlur, onChange = props.onChange, required = props.required, rows = props.rows, value = props.value, sx = props.sx, type = props.type, _a = props.debounceTime, debounceTime = _a === void 0 ? 300 : _a, maxLength = props.maxLength, placeholder = props.placeholder, onDrag = props.onDrag, autoFocus = props.autoFocus, hideMaxLengthText = props.hideMaxLengthText;
    var _b = useState(value), fieldValue = _b[0], setFieldValue = _b[1];
    var _c = useState(0), currentCharacterCount = _c[0], setCurrentCharacterCount = _c[1];
    useEffect(function () {
        var _a;
        setFieldValue(value);
        setCurrentCharacterCount((_a = value === null || value === void 0 ? void 0 : value.length) !== null && _a !== void 0 ? _a : 0);
    }, [value]);
    var debouncedHandleChange = useMemo(function () {
        return debounce(function (event) {
            onChange(event);
        }, debounceTime);
    }, [debounceTime, onChange]);
    var remainingCharacters = useMemo(function () {
        if (maxLength) {
            return Math.max(maxLength - currentCharacterCount, 0) + " characters remaining";
        }
        return '';
    }, [currentCharacterCount, maxLength]);
    return (jsxs(FormControl, __assign({ error: !!errorText, fullWidth: fullWidth, required: required, disabled: disabled }, { children: [jsx(FormLabel, __assign({ sx: { fontSize: labelFontSize } }, { children: label }), void 0),
            jsx(OutlinedInput, { autoFocus: autoFocus, disabled: disabled, name: name, onBlur: onBlur, onChange: function (event) {
                    var _a, _b;
                    setFieldValue(event.target.value);
                    debouncedHandleChange(event);
                    setCurrentCharacterCount((_b = (_a = event.target.value) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0);
                }, required: required, multiline: !!rows, rows: rows, value: fieldValue !== null && fieldValue !== void 0 ? fieldValue : '', sx: sx, inputProps: { maxLength: maxLength, onDrag: onDrag }, placeholder: placeholder, type: type }, void 0),
            maxLength && !hideMaxLengthText ? jsx(FormHelperText, { children: remainingCharacters }, void 0) : jsx(Fragment, {}, void 0),
            jsx(FormHelperText, { children: errorText }, void 0)] }), void 0));
});

var FormNumberInput = React__default.memo(function (props) {
    var disabled = props.disabled, error = props.error, errorText = props.errorText, fullWidth = props.fullWidth, label = props.label, labelFontSize = props.labelFontSize, name = props.name, onBlur = props.onBlur, onChange = props.onChange, required = props.required, value = props.value, inputProps = props.inputProps, sx = props.sx, _a = props.isCurrency, isCurrency = _a === void 0 ? false : _a, _b = props.debounceTime, debounceTime = _b === void 0 ? 300 : _b, _c = props.disableScrollChange, disableScrollChange = _c === void 0 ? true : _c;
    var _d = useState(value), fieldValue = _d[0], setFieldValue = _d[1];
    useEffect(function () {
        setFieldValue(value);
    }, [value]);
    var debouncedHandleChange = useMemo(function () { return debounce$1(function (event) {
        onChange(event);
    }, debounceTime); }, [onChange, debounceTime]);
    var mergedInputProps = inputProps ? __assign({}, inputProps) : {};
    if (isCurrency && mergedInputProps.step === undefined) {
        mergedInputProps.step = '1';
    }
    if (disableScrollChange) {
        var existingOnWheel_1 = mergedInputProps.onWheel;
        mergedInputProps.onWheel = function (event) {
            var target = event.currentTarget;
            if (target && typeof target.blur === 'function') {
                target.blur();
            }
            if (existingOnWheel_1) {
                existingOnWheel_1(event);
            }
        };
    }
    var finalInputProps = Object.keys(mergedInputProps).length ? mergedInputProps : undefined;
    return (jsxs(FormControl, __assign({ error: error, fullWidth: fullWidth, required: required, disabled: disabled }, { children: [jsx(FormLabel, __assign({ sx: { fontSize: labelFontSize } }, { children: label }), void 0),
            jsx(OutlinedInput, { disabled: disabled, name: name, onBlur: onBlur, onChange: function (event) {
                    setFieldValue(event.target.valueAsNumber);
                    debouncedHandleChange(event);
                }, type: 'number', required: required, value: fieldValue !== null && fieldValue !== void 0 ? fieldValue : '', inputProps: finalInputProps, sx: sx, startAdornment: isCurrency ? jsx(InputAdornment, __assign({ position: "start" }, { children: "$" }), void 0) : undefined }, void 0),
            jsx(FormHelperText, { children: errorText }, void 0)] }), void 0));
});

var IEntityAutocomplete = React__default.memo(function (props) {
    var value = props.value, onChange = props.onChange, disabled = props.disabled, options = props.options, isLoading = props.isLoading, getOptionLabel = props.getOptionLabel, error = props.error, validate = props.validate, inactiveOverrideText = props.inactiveOverrideText;
    var _a = useState(false), isOpen = _a[0], setIsOpen = _a[1];
    var _b = useState(false), isChanged = _b[0], setIsChanged = _b[1];
    useEffect(function () {
        if (isChanged && validate) {
            validate();
            setIsChanged(false);
        }
    }, [isChanged, validate, value]);
    var getLabel = function (option) {
        return "" + (getOptionLabel !== undefined ? getOptionLabel(option) : "") + (option.isActive ? '' : (inactiveOverrideText ? ' (' + inactiveOverrideText + ')' : ' (Inactive)'));
    };
    return (jsx(Autocomplete, { value: value !== null && value !== void 0 ? value : null, onChange: function (event, value) { onChange === null || onChange === void 0 ? void 0 : onChange(event, value); setIsChanged(true); }, open: isOpen, disabled: disabled, onOpen: function () { return setIsOpen(true); }, onClose: function () { return setIsOpen(false); }, options: options !== null && options !== void 0 ? options : [], loading: isLoading, onBlur: validate, isOptionEqualToValue: function (option, value) { return (option === null || option === void 0 ? void 0 : option.id) === (value === null || value === void 0 ? void 0 : value.id); }, getOptionLabel: getLabel, renderInput: function (params) { return (jsx(TextField, __assign({}, params, { error: error, onBlur: validate, InputProps: __assign(__assign({}, params.InputProps), { endAdornment: (jsxs(Fragment, { children: [isLoading ? jsx(CircularProgress, { color: 'inherit', size: 20 }, void 0) : null, params.InputProps.endAdornment] }, void 0)) }) }), void 0)); }, renderOption: function (props, option) {
            return (createElement("li", __assign({}, props, { key: option.id }), getLabel(option)));
        } }, void 0));
});

var IEntitySelect = React__default.memo(function (props) {
    var value = props.value, onChange = props.onChange, menuItems = props.menuItems, getItem = props.getItem, getItemText = props.getItemText, onBlur = props.onBlur, error = props.error, required = props.required, disabled = props.disabled;
    var _a = useState(value), selectValue = _a[0], setSelectValue = _a[1];
    var onChangeCallback = useCallback(onChange, [onChange]);
    var getMenuItem = useCallback(function (item) {
        if (item.id === value || item.isActive) {
            if (getItem != null) {
                return jsx(MenuItem, __assign({ value: item.id }, { children: getItem(item) }), item.id);
            }
            else if (getItemText != null) {
                return jsx(MenuItem, __assign({ value: item.id }, { children: getItemText(item) + (item.isActive ? "" : " (Inactive)") }), item.id);
            }
            else {
                return jsx(Fragment, {}, void 0);
            }
        }
    }, [value, getItemText, getItem]);
    return (jsxs(Select, __assign({ value: selectValue, onChange: function (event, child) {
            setSelectValue(event.target.value);
            onChangeCallback(event, child);
        }, onBlur: onBlur, error: error, required: required, disabled: disabled }, { children: [jsx(MenuItem, __assign({ value: '' }, { children: jsx("em", { children: "None" }, void 0) }), 'none'),
            menuItems && menuItems.map(function (item) { return getMenuItem(item); })] }), void 0));
});

var Year = { validate: /^([1-2][0-9]{3}){0,1}$/, input: /^([1-2]|[1-2][0-9]{0,3})$/ };
var Hour = { validate: /^(([1-9])|(0[1-9])|(1[0-2]))$/, input: /^(([0-9])|(0[1-9])|(1[0-2]))$/ };
var Minute = { validate: /^[0-5][0-9]$/, input: /^[0-5][0-9]?$/ };
var Currency = { validate: /^[0-9]*(\.[0-9][0-9])?$/, input: /^[0-9]*(\.[0-9]{0,2})?$/ };
var Decimal = { validate: /^[0-9]*(\.[0-9]+)?$/, input: /^[0-9]*(\.[0-9]*)?$/ };
var Inches = { validate: /^[0-9]+(\.((50?)|([2,7]5)|(0{1,2})))?$/, input: /^[0-9]+(\.((50?)|([2,7]5?)|0{1,2})?)?$/ };

var FormSection = function (_a) {
    var hideBorder = _a.hideBorder, backgroundColor = _a.backgroundColor, fullWidth = _a.fullWidth, fullHeight = _a.fullHeight, children = _a.children;
    return (jsx(Paper, __assign({ elevation: 0, sx: { border: hideBorder ? 'none' : 'solid 1px #AAAAAA', padding: '24px', backgroundColor: backgroundColor, width: fullWidth ? '100%' : undefined, height: fullHeight ? '100%' : undefined } }, { children: jsx(Grid, __assign({ container: true, direction: "column", spacing: 2 }, { children: children }), void 0) }), void 0));
};

function areObjectsEqual(objectA, objectB) {
    return Object.keys(objectA).every(function (key) { return objectA[key] === objectB[key]; });
}
function areObjectsDifferent(objectA, objectB) {
    return !areObjectsEqual(objectA, objectB);
}

function useStandardValidatedFormManager(initialRecord, formValidationConfig) {
    var _a = useState(_.cloneDeep(initialRecord)), formRecord = _a[0], setFormRecord = _a[1];
    var isFormDirty = useMemo(function () { return areObjectsDifferent(formRecord, initialRecord); }, [initialRecord, formRecord]);
    var _b = useState(new Map()), fieldErrors = _b[0], setFieldErrors = _b[1];
    useEffect(function () {
        setFormRecord(_.cloneDeep(initialRecord));
    }, [initialRecord]);
    var validateForm = useCallback(function () {
        if (!formRecord) {
            setFieldErrors(new Map());
            return false;
        }
        var validationResult = runFormValidation(formRecord, formValidationConfig);
        setFieldErrors(validationResult.errorMessages);
        return validationResult.isValid;
    }, [formRecord]);
    var validateField = useCallback(function (fieldName, updatedValue) {
        var fieldValidationConfig = formValidationConfig.get(fieldName);
        if (fieldValidationConfig) {
            var _a = runFieldValidation(updatedValue, fieldValidationConfig), errorMessage = _a.errorMessage, isValid = _a.isValid;
            if (errorMessage !== fieldErrors.get(fieldName)) {
                var updatedFieldErrors = _.cloneDeep(fieldErrors);
                updatedFieldErrors.set(fieldName, errorMessage);
                setFieldErrors(updatedFieldErrors);
            }
            return isValid;
        }
        return true;
    }, [fieldErrors]);
    var handleTextFieldChange = useCallback(function (event) {
        var targetName = event.target.name;
        setFormRecord(function (currentRecord) { return (__assign({}, _.set(currentRecord, targetName, event.target.value))); });
        validateField(targetName, event.target.value);
    }, [validateField]);
    var resetForm = useCallback(function () {
        setFormRecord(_.cloneDeep(initialRecord));
    }, [initialRecord]);
    return {
        formRecord: formRecord,
        setFormRecord: setFormRecord,
        isFormDirty: isFormDirty,
        fieldErrors: fieldErrors,
        validateForm: validateForm,
        validateField: validateField,
        handleTextFieldChange: handleTextFieldChange,
        resetForm: resetForm
    };
}

var StyledSnackbar = styled(SnackbarContent)({
    '@media (min-width:600px)': {
        minWidth: '344px !important'
    }
});
var BulkErrorSnackbar = forwardRef(function (_a, ref) {
    var _b;
    var props = __rest(_a, []);
    var theme = useTheme();
    var closeSnackbar = useSnackbar().closeSnackbar;
    var _c = useState(false), expanded = _c[0], setExpanded = _c[1];
    var handleExpandClick = useCallback(function () {
        setExpanded(function (oldExpanded) { return !oldExpanded; });
    }, []);
    var handleDismiss = useCallback(function () {
        closeSnackbar(props.id);
    }, [props, closeSnackbar]);
    return (jsx(StyledSnackbar, __assign({ ref: ref }, { children: jsxs(Card, __assign({ sx: {
                width: '100%',
                backgroundColor: theme.palette.error.main
            } }, { children: [jsxs(CardActions, __assign({ sx: {
                        padding: '8px 8px 8px 16px',
                        justifyContent: 'space-between'
                    } }, { children: [jsx(Typography, __assign({ variant: 'body2', sx: {
                                color: theme.palette.error.contrastText
                            } }, { children: props.message }), void 0),
                        jsxs("div", __assign({ style: { marginLeft: 'auto' } }, { children: [jsx(IconButton, __assign({ "aria-label": 'Show more', size: 'small', sx: {
                                        padding: '8px 8px',
                                        transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
                                        color: theme.palette.error.contrastText,
                                        transition: 'all .2s'
                                    }, onClick: handleExpandClick }, { children: jsx(ExpandMore, {}, void 0) }), void 0),
                                jsx(IconButton, __assign({ size: 'small', sx: {
                                        padding: '8px 8px',
                                        transform: expanded ? 'rotate(0deg)' : 'rotate(180deg)',
                                        color: theme.palette.error.contrastText,
                                        transition: 'all .2s'
                                    }, onClick: handleDismiss }, { children: jsx(Close, { fontSize: 'small' }, void 0) }), void 0)] }), void 0)] }), void 0),
                jsx(Collapse, __assign({ in: expanded, timeout: 'auto', unmountOnExit: true }, { children: jsx(Paper, __assign({ sx: {
                            backgroundColor: theme.palette.error.contrastText,
                            padding: '8px 24px 8px 0px',
                        } }, { children: jsx("ul", { children: (_b = props.errorMessages) === null || _b === void 0 ? void 0 : _b.map(function (x) {
                                return jsx("li", { children: x }, void 0);
                            }) }, void 0) }), void 0) }), void 0)] }), void 0) }), void 0));
});
BulkErrorSnackbar.displayName = 'BulkError';

function useStandardSnackbar(isVisible, message, variant, onSnackbarDisplay, additionalOptions, errorMessages) {
    var enqueueSnackbar = useSnackbar().enqueueSnackbar;
    useEffect(function () {
        if (isVisible) {
            var messageWithProperCase = message.charAt(0).toUpperCase() + message.slice(1);
            if (errorMessages && errorMessages.length > 0) {
                enqueueSnackbar(messageWithProperCase, __assign(__assign({}, additionalOptions), { variant: variant, preventDuplicate: true, content: function (key, message) { return jsx(BulkErrorSnackbar, { id: key, message: message, errorMessages: errorMessages }, void 0); } }));
            }
            else {
                enqueueSnackbar(messageWithProperCase, __assign(__assign({}, additionalOptions), { variant: variant, preventDuplicate: true }));
            }
            onSnackbarDisplay && onSnackbarDisplay();
        }
    }, 
    // eslint-disable-next-line
    [isVisible, enqueueSnackbar, message, variant]);
}

function useActivateInactivateSnackbar(mode, entityNameSingular, entityNamePlural, activateInactivateResult, onSnackbarDisplay) {
    if (activateInactivateResult === void 0) { activateInactivateResult = { numSuccessful: 0, numFailed: 0, errorMessages: [] }; }
    if (onSnackbarDisplay === void 0) { onSnackbarDisplay = function () { }; }
    var numSuccessful = activateInactivateResult.numSuccessful, numFailed = activateInactivateResult.numFailed, errorMessages = activateInactivateResult.errorMessages;
    var totalRecordsUpdated = numSuccessful + numFailed;
    var successEntityName = totalRecordsUpdated === 1 ? entityNameSingular : numSuccessful + " " + entityNamePlural;
    var successMessage = successEntityName + " Successfully " + makePastTense(mode);
    var shouldShowSuccess = numSuccessful > 0;
    useStandardSnackbar(shouldShowSuccess, successMessage, 'success', onSnackbarDisplay);
    var failedEntityName = totalRecordsUpdated === 1 ? entityNameSingular : numFailed + " " + entityNamePlural;
    var message = "An Error occurred while attempting to " + mode + " " + failedEntityName;
    var shouldShowFailed = numFailed > 0;
    useStandardSnackbar(shouldShowFailed, message, 'error', onSnackbarDisplay, {
        persist: errorMessages && errorMessages.length > 0 ? true : false,
    }, errorMessages);
}
function makePastTense(value) {
    if (value.endsWith('e')) {
        return value + "d";
    }
    else {
        return value + "ed";
    }
}

function useBulkActionSnackbar(pastTenseActionName, presentTestActionName, entityNameSingular, entityNamePlural, activateInactivateResult, onSnackbarDisplay) {
    if (activateInactivateResult === void 0) { activateInactivateResult = { numSuccessful: 0, numFailed: 0, errorMessages: [] }; }
    if (onSnackbarDisplay === void 0) { onSnackbarDisplay = function () { }; }
    var numSuccessful = activateInactivateResult.numSuccessful, numFailed = activateInactivateResult.numFailed, errorMessages = activateInactivateResult.errorMessages;
    var totalRecordsUpdated = numSuccessful + numFailed;
    var successEntityName = totalRecordsUpdated === 1 ? entityNameSingular : numSuccessful + " " + entityNamePlural;
    var successMessage = successEntityName + " Successfully " + pastTenseActionName;
    var shouldShowSuccess = numSuccessful > 0;
    useStandardSnackbar(shouldShowSuccess, successMessage, 'success', onSnackbarDisplay);
    var failedEntityName = totalRecordsUpdated === 1 ? entityNameSingular : numFailed + " " + entityNamePlural;
    var message = "An Error occurred while attempting to " + presentTestActionName + " " + failedEntityName;
    var shouldShowFailed = numFailed > 0;
    useStandardSnackbar(shouldShowFailed, message, 'error', onSnackbarDisplay, {
        persist: errorMessages && errorMessages.length > 0 ? true : false,
    }, errorMessages);
}

var checkForCustomErrorMessage = function (errorObject) {
    var _a, _b;
    var apiErrorMessage = (_b = (_a = errorObject === null || errorObject === void 0 ? void 0 : errorObject.data) === null || _a === void 0 ? void 0 : _a.detail) !== null && _b !== void 0 ? _b : errorObject === null || errorObject === void 0 ? void 0 : errorObject.data;
    if (apiErrorMessage && typeof apiErrorMessage === 'string') {
        return apiErrorMessage;
    }
    return '';
};

function useFailedActionSnackbar(presentTenseVerb, entityName, isVisible, onSnackbarDisplay, errorObject) {
    if (errorObject === void 0) { errorObject = null; }
    var message = useMemo(function () {
        var customErrorMessage = checkForCustomErrorMessage(errorObject);
        if (!!customErrorMessage) {
            return customErrorMessage;
        }
        return "An error occurred while attempting to " + presentTenseVerb + " " + entityName;
    }, [entityName, presentTenseVerb, errorObject]);
    useStandardSnackbar(isVisible, message, 'error', onSnackbarDisplay);
}

function useFailedCreateSnackbar(entityName, isCreateSuccessful, onSnackbarDisplay, errorObject) {
    if (onSnackbarDisplay === void 0) { onSnackbarDisplay = function () { }; }
    if (errorObject === void 0) { errorObject = null; }
    var message = useMemo(function () {
        var customErrorMessage = checkForCustomErrorMessage(errorObject);
        if (!!customErrorMessage) {
            return customErrorMessage;
        }
        return "An Error occurred while attempting to create " + entityName + ". Please try again, if the issue persists contact technical support.";
    }, [entityName, errorObject]);
    useStandardSnackbar(isCreateSuccessful, message, 'error', onSnackbarDisplay);
}

function useFailedUpdateSnackbar(entityName, isCreateSuccessful, onSnackbarDisplay, errorObject) {
    if (onSnackbarDisplay === void 0) { onSnackbarDisplay = function () { }; }
    if (errorObject === void 0) { errorObject = null; }
    var message = useMemo(function () {
        var customErrorMessage = checkForCustomErrorMessage(errorObject);
        if (!!customErrorMessage) {
            return customErrorMessage;
        }
        return "An error occurred while attempting to update " + entityName.toLowerCase();
    }, [entityName, errorObject]);
    useStandardSnackbar(isCreateSuccessful, message, 'error', onSnackbarDisplay);
}

function useSuccessfulActionSnackbar(pastTenseVerb, entityName, isVisible, onSnackbarDisplay) {
    if (onSnackbarDisplay === void 0) { onSnackbarDisplay = function () { }; }
    var message = useMemo(function () {
        return entityName + " successfully " + pastTenseVerb;
    }, [entityName, pastTenseVerb]);
    useStandardSnackbar(isVisible, message, 'success', onSnackbarDisplay);
}

function useSuccessfulCreateSnackbar(entityName, isCreateSuccessful, onSnackbarDisplay) {
    if (onSnackbarDisplay === void 0) { onSnackbarDisplay = function () { }; }
    var message = useMemo(function () {
        return entityName + " Successfully Created";
    }, [entityName]);
    useStandardSnackbar(isCreateSuccessful, message, 'success', onSnackbarDisplay);
}

function useSuccessfulUpdateSnackbar(entityName, isCreateSuccessful, onSnackbarDisplay) {
    if (onSnackbarDisplay === void 0) { onSnackbarDisplay = function () { }; }
    var message = useMemo(function () {
        return entityName + " Successfully Updated";
    }, [entityName]);
    useStandardSnackbar(isCreateSuccessful, message, 'success', onSnackbarDisplay);
}

var ExpandMoreButton = styled(function (props) {
    props.expand; var other = __rest(props, ["expand"]);
    return jsx(IconButton, __assign({}, other), void 0);
})(function (_a) {
    var theme = _a.theme, expand = _a.expand;
    return ({
        transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
    });
});
var StandardCardWithHeader = function (props) {
    var headerTitle = props.headerTitle, headerIcon = props.headerIcon, _a = props.isOpenInitially, isOpenInitially = _a === void 0 ? true : _a, headerChildren = props.headerChildren;
    var _b = useState(isOpenInitially), expanded = _b[0], setExpanded = _b[1];
    var theme = useTheme();
    var handleExpandClick = function () {
        setExpanded(!expanded);
    };
    return (jsxs(Card, __assign({ variant: 'outlined', sx: { height: expanded ? '100%' : 'auto' } }, { children: [jsx(CardHeader, { sx: {
                    backgroundColor: theme.palette.primary.main,
                    color: theme.palette.primary.contrastText
                }, title: jsxs(Stack, __assign({ direction: "row", alignItems: "center", gap: 1 }, { children: [headerIcon, jsx(Typography, __assign({ variant: 'h3', mr: 2 }, { children: headerTitle }), void 0), headerChildren] }), void 0), action: jsx(ExpandMoreButton, __assign({ expand: expanded, onClick: handleExpandClick, size: 'small', disableRipple: true, sx: {
                        color: theme.palette.primary.main,
                        backgroundColor: 'white !important',
                    } }, { children: jsx(ExpandMore, {}, void 0) }), void 0) }, void 0),
            jsx(Collapse, __assign({ in: expanded, timeout: 'auto', unmountOnExit: true }, { children: jsx(CardContent, __assign({ sx: { padding: '16px 0px 0px 0px', paddingBottom: '0px !important' } }, { children: props.children }), void 0) }), void 0)] }), void 0));
};

var LoadingBackdrop = function (props) {
    var loadingOptions = props.loadingOptions;
    var getCurrentLoadingMessage = useMemo(function () {
        var _a;
        return (_a = loadingOptions.find(function (option) { return option.isLoading; })) === null || _a === void 0 ? void 0 : _a.loadingMessage;
    }, [loadingOptions]);
    return (jsx(Backdrop, __assign({ sx: { color: '#fff', zIndex: function (theme) { return theme.zIndex.modal + 1; } }, open: !!getCurrentLoadingMessage }, { children: jsx(Box, { children: jsxs(Grid, __assign({ container: true, direction: 'column', spacing: 2, justifyContent: 'center' }, { children: [jsx(Grid, __assign({ item: true, xs: 12, justifyContent: 'center' }, { children: jsx("div", __assign({ style: { display: 'flex', justifyContent: 'center' } }, { children: jsx(CircularProgress, { color: 'inherit' }, void 0) }), void 0) }), void 0),
                    jsx(Grid, __assign({ item: true, xs: 12, justifyContent: 'center' }, { children: jsx(Typography, __assign({ variant: 'h3' }, { children: getCurrentLoadingMessage }), void 0) }), void 0)] }), void 0) }, void 0) }), void 0));
};

var LoadingIndicator = /** @class */ (function (_super) {
    __extends(LoadingIndicator, _super);
    function LoadingIndicator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LoadingIndicator.prototype.render = function () {
        return (jsx(Grid, __assign({ container: true, justifyContent: "center", alignItems: "stretch", sx: { padding: '20px' } }, { children: jsx(Grid, __assign({ item: true }, { children: jsx(CircularProgress, { id: "loading-indicator" }, void 0) }), void 0) }), void 0));
    };
    return LoadingIndicator;
}(React.Component));

var NavBreadcrumbs = function (props) {
    var links = props.links, currentPageLabel = props.currentPageLabel, editRoute = props.editRoute, isDense = props.isDense;
    var navigate = useNavigate();
    var handleClick = function (navLink) { return function (event) {
        event.preventDefault();
        navigate(navLink);
    }; };
    var fontStyles = isDense ? { fontSize: 14 } : {};
    return (jsxs(Breadcrumbs, __assign({ separator: jsx(NavigateNext, { fontSize: isDense ? 'inherit' : 'small' }, void 0) }, { children: [links.map(function (link, index) {
                return link.isText ? (jsx(Typography, __assign({ sx: fontStyles }, { children: link.label }), index)) : (jsx(Link, __assign({ underline: 'hover', color: 'primary', href: link.navLink, onClick: handleClick(link.navLink), sx: fontStyles }, { children: link.label }), index + "-" + link.navLink));
            }),
            jsxs("div", __assign({ style: { display: 'flex', flexDirection: 'row', alignItems: 'center' } }, { children: [jsx(Typography, __assign({ sx: fontStyles }, { children: currentPageLabel }), void 0), editRoute ? jsx(Tooltip, __assign({ title: 'Edit' }, { children: jsx(Button, __assign({ href: editRoute }, { children: jsx(Edit, {}, void 0) }), void 0) }), void 0) : ''] }), void 0)] }), void 0));
};

var SlimPageHeader = function (props) {
    var icon = props.icon, title = props.title, titleStyles = props.titleStyles, breadCrumbProps = props.breadCrumbProps, endSlot = props.endSlot, onTitleChange = props.onTitleChange, onEditClicked = props.onEditClicked, _a = props.color, color = _a === void 0 ? 'default' : _a, disableBorderRadius = props.disableBorderRadius, endTitleSlot = props.endTitleSlot, disableGutters = props.disableGutters, _b = props.titleFontSize, titleFontSize = _b === void 0 ? 24 : _b, _c = props.titleMaxWidth, titleMaxWidth = _c === void 0 ? '600px' : _c;
    var _d = useState(false), isEditing = _d[0], setIsEditing = _d[1];
    var _e = useState(''), editedTitle = _e[0], setEditedTitle = _e[1];
    var isEditable = useMemo(function () { return !!onTitleChange || !!onEditClicked; }, [onTitleChange, onEditClicked]);
    var theme = useTheme();
    var handleEdit = useCallback(function () {
        if (onEditClicked) {
            onEditClicked();
        }
        if (onTitleChange) {
            setEditedTitle(title);
            setIsEditing(true);
        }
    }, [title, onEditClicked, onTitleChange]);
    var handleTitleEdit = function (e) {
        setEditedTitle(e.target.value);
    };
    var handleApply = useCallback(function () {
        if (onTitleChange) {
            onTitleChange(editedTitle);
        }
        setIsEditing(false);
    }, [onTitleChange, editedTitle]);
    var handleCancel = function () {
        setIsEditing(false);
    };
    var palette = useMemo(function () {
        switch (color) {
            case 'primary':
                return {
                    background: theme.palette.primary.main,
                    textColor: theme.palette.primary.contrastText
                };
            case 'transparent':
                return {
                    background: 'none',
                    textColor: theme.palette.text.primary
                };
            default:
                return {
                    background: '#fff',
                    textColor: theme.palette.text.primary
                };
        }
    }, [color, theme]);
    var renderTitle = useCallback(function () {
        if (isEditing) {
            return jsx(TextField, { value: editedTitle, onChange: handleTitleEdit, size: 'small', margin: 'none', sx: { width: 400 } }, void 0);
        }
        return (jsx(Typography, __assign({ fontSize: titleFontSize, fontWeight: 'bold', sx: titleStyles, ml: 1, noWrap: true }, { children: title }), void 0));
    }, [title, isEditing, editedTitle, titleFontSize, titleStyles, handleTitleEdit]);
    var renderTitleActions = useCallback(function () {
        if (!isEditable) {
            return null;
        }
        if (isEditing) {
            return (jsxs(Fragment, { children: [jsx(Tooltip, __assign({ title: 'Cancel' }, { children: jsx(IconButton, __assign({ size: 'small', onClick: handleCancel, color: 'error' }, { children: jsx(Close, {}, void 0) }), void 0) }), void 0),
                    jsx(Tooltip, __assign({ title: 'Apply' }, { children: jsx(IconButton, __assign({ size: 'small', onClick: handleApply, color: 'success', disabled: editedTitle.length === 0 }, { children: jsx(Check, {}, void 0) }), void 0) }), void 0)] }, void 0));
        }
        else {
            return (jsx(IconButton, __assign({ size: 'small', onClick: handleEdit }, { children: jsx(Edit, {}, void 0) }), void 0));
        }
    }, [handleEdit, isEditing, isEditable, handleApply, editedTitle]);
    var renderEndTitleSlot = useCallback(function () {
        if (!endTitleSlot) {
            return null;
        }
        return endTitleSlot;
    }, [endTitleSlot]);
    return (jsx(Paper, __assign({ elevation: 0, sx: { background: palette.background, color: palette.textColor }, square: disableBorderRadius }, { children: jsxs(Grid, __assign({ container: true, direction: 'row', justifyContent: 'space-between', pl: disableGutters ? 0 : 2 }, { children: [jsxs(Grid, __assign({ item: true }, { children: [jsxs(Grid, __assign({ item: true, sx: { display: 'flex', alignContent: 'center', alignItems: 'center' } }, { children: [icon, " ", jsx("div", __assign({ style: { display: 'block', maxWidth: titleMaxWidth } }, { children: renderTitle() }), void 0), renderTitleActions(), renderEndTitleSlot()] }), void 0),
                        breadCrumbProps && (jsx(Grid, __assign({ item: true }, { children: jsx(NavBreadcrumbs, __assign({}, breadCrumbProps, { isDense: true }), void 0) }), void 0))] }), void 0),
                endSlot && (jsx(Grid, __assign({ item: true, container: true, direction: 'row', xs: 'auto', maxWidth: '100% !important', alignContent: 'end' }, { children: jsx(Grid, __assign({ item: true }, { children: endSlot }), void 0) }), void 0))] }), void 0) }), void 0));
};

var SlimFormHeader = function (props) {
    var additionalHeaderItems = props.additionalHeaderItems, _a = props.additionalMenuItems, additionalMenuItems = _a === void 0 ? null : _a, breadcrumbs = props.breadcrumbs, _b = props.canInactivate, canInactivate = _b === void 0 ? true : _b, _c = props.canSave, canSave = _c === void 0 ? true : _c, inactivateConfig = props.inactivateConfig, handleCancel = props.handleCancel, handleIsActiveChange = props.handleIsActiveChange, handleSave = props.handleSave, icon = props.icon, isActive = props.isActive, isFormDirty = props.isFormDirty, isLoading = props.isLoading, permissionsTypeName = props.permissionsTypeName, title = props.title, _d = props.saveButtonConfig, saveButtonConfig = _d === void 0 ? {
        text: 'Save',
        icon: jsx(Save, {}, void 0)
    } : _d;
    var _e = useState(null), menuAnchorEl = _e[0], setMenuAnchorEl = _e[1];
    var _f = useState(false), isInactivateConfirmationDialogOpen = _f[0], setIsInactivateConfirmationDialogOpen = _f[1];
    var handleMenuOpen = function (event) {
        setMenuAnchorEl(event.currentTarget);
    };
    var handleMenuClose = function (afterClose) { return function () {
        setMenuAnchorEl(null);
        if (afterClose) {
            afterClose();
        }
    }; };
    var onInactivate = function () {
        if (inactivateConfig === null || inactivateConfig === void 0 ? void 0 : inactivateConfig.inactivateHandler) {
            inactivateConfig.inactivateHandler();
        }
    };
    return (jsxs(Grid, __assign({ item: true, xs: 12 }, { children: [jsx(SlimPageHeader, { icon: icon, title: title, breadCrumbProps: {
                    links: breadcrumbs,
                    currentPageLabel: title,
                }, endSlot: jsx(Grid, __assign({ item: true, container: true, direction: 'row', alignItems: 'start', py: 1 }, { children: jsxs(Grid, __assign({ item: true, display: 'flex', alignItems: 'center', justifyContent: 'end', xs: 12, sx: { gap: 1 }, pr: 2 }, { children: [handleIsActiveChange && (jsx(FormControlLabel, { control: jsx(Switch, { checked: isActive, onChange: function (_, isChecked) { return handleIsActiveChange(isChecked); }, size: 'small', sx: { mr: 1 } }, void 0), label: 'Active', labelPlacement: 'start', disabled: isLoading }, void 0)),
                            canInactivate && (jsx(Fragment, { children: jsx(AuthenticatedComponent, __assign({ requiredPermissions: ["inactivate:" + permissionsTypeName] }, { children: jsx(Tooltip, __assign({ title: 'Delete' }, { children: jsx("span", { children: jsx(IconButton, __assign({ size: 'large', onClick: function () {
                                                    if (inactivateConfig) {
                                                        setIsInactivateConfirmationDialogOpen(true);
                                                    }
                                                    else {
                                                        onInactivate();
                                                    }
                                                }, disabled: isLoading }, { children: jsx(Delete, { fontSize: 'inherit' }, void 0) }), void 0) }, void 0) }), void 0) }), void 0) }, void 0)), additionalHeaderItems, jsx(Button, __assign({ variant: 'outlined', color: 'primary', size: 'small', onClick: handleCancel, startIcon: jsx(Cancel, {}, void 0), sx: { width: 90 } }, { children: isFormDirty ? 'Cancel' : 'Close' }), void 0),
                            handleSave && (jsxs(Fragment, { children: [jsx(Button, __assign({ variant: 'contained', color: 'primary', size: 'small', onClick: handleSave, disabled: isLoading || !canSave, startIcon: saveButtonConfig.icon, sx: { width: 90 } }, { children: saveButtonConfig.text }), void 0),
                                    jsx(IconButton, __assign({ onClick: handleMenuOpen }, { children: jsx(MoreVert, { fontSize: 'inherit' }, void 0) }), void 0)] }, void 0)),
                            jsxs(Menu, __assign({ anchorEl: menuAnchorEl, open: !!menuAnchorEl, onClose: handleMenuClose(), anchorOrigin: {
                                    vertical: 'bottom',
                                    horizontal: 'center',
                                }, transformOrigin: {
                                    vertical: 'top',
                                    horizontal: 'right',
                                } }, { children: [jsx(MenuItem, __assign({ onClick: handleMenuClose(handleSave), disabled: isLoading || !canSave }, { children: saveButtonConfig.text }), void 0),
                                    handleCancel && jsx(MenuItem, __assign({ onClick: handleMenuClose(handleCancel) }, { children: isFormDirty ? 'Cancel' : 'Close' }), void 0),
                                    additionalMenuItems &&
                                        additionalMenuItems.map(function (additionalMenuItem) { return (jsx(MenuItem, __assign({ onClick: additionalMenuItem.onClick, disabled: additionalMenuItem.disabled }, { children: additionalMenuItem.name }), void 0)); }),
                                    canInactivate && (jsx(AuthenticatedComponent, __assign({ requiredPermissions: ["inactivate:" + permissionsTypeName] }, { children: jsx(MenuItem, __assign({ onClick: handleMenuClose(function () {
                                                if (inactivateConfig) {
                                                    setIsInactivateConfirmationDialogOpen(true);
                                                }
                                                else {
                                                    onInactivate();
                                                }
                                            }), disabled: isLoading }, { children: "Delete" }), void 0) }), void 0))] }), void 0)] }), void 0) }), void 0) }, void 0),
            inactivateConfig && (jsx(ConfirmationModalWrapper, __assign({ isOpen: isInactivateConfirmationDialogOpen, title: inactivateConfig.title, cancel: function () { return setIsInactivateConfirmationDialogOpen(false); }, confirm: function () {
                    setIsInactivateConfirmationDialogOpen(false);
                    onInactivate();
                } }, { children: inactivateConfig.content }), void 0))] }), void 0));
};

var StandardIsActiveToggle = function (props) {
    var objectId = props.objectId, isActive = props.isActive, archiveMutation = props.archiveMutation, archiveSuccess = props.archiveSuccess, resetArchive = props.resetArchive, unarchiveMutation = props.unarchiveMutation, unarchiveSuccess = props.unarchiveSuccess, resetUnarchive = props.resetUnarchive, currentObject = props.currentObject, setCurrentObject = props.setCurrentObject, className = props.className;
    var enqueueSnackbar = useSnackbar().enqueueSnackbar;
    useEffect(function () {
        if (archiveSuccess) {
            enqueueSnackbar(className + " is now inactive");
            resetArchive();
        }
        if (unarchiveSuccess) {
            enqueueSnackbar(className + "is now active");
            resetUnarchive();
        }
    }, [archiveMutation, unarchiveMutation, archiveSuccess, unarchiveSuccess, resetArchive, resetUnarchive, className, enqueueSnackbar]);
    var handleChangeIsActiveStatus = function (event) {
        if (objectId) {
            if (event.target.checked) {
                unarchiveMutation(objectId);
            }
            else {
                archiveMutation(objectId);
            }
        }
    };
    var handleActiveToggleChange = function (event) {
        handleChangeIsActiveStatus(event);
        setCurrentObject(__assign(__assign({}, currentObject), { isActive: event.target.checked }));
    };
    return (jsx(FormControlLabel, { control: jsx(Switch, { checked: isActive, disabled: !objectId, onChange: handleActiveToggleChange }, void 0), label: 'Active', labelPlacement: 'start' }, void 0));
};

var StandardSearchInput = function (props) {
    var searchText = props.searchText, handleSearchChange = props.handleSearchChange, isLoading = props.isLoading, textFieldProps = props.textFieldProps;
    var _a = useState(searchText), inputText = _a[0], setInputText = _a[1];
    // eslint-disable-next-line
    var debouncedSearchInputHandler = useCallback(debounce(handleSearchChange, 500), []);
    useEffect(function () {
        debouncedSearchInputHandler(inputText);
    }, [inputText, debouncedSearchInputHandler]);
    var handleInputChange = function (event) {
        setInputText(event.target.value);
    };
    return (jsx(TextField, __assign({ id: 'search-box', value: inputText, onChange: handleInputChange, InputProps: {
            startAdornment: (jsx(InputAdornment, __assign({ position: 'start' }, { children: jsx(Search, {}, void 0) }), void 0)),
            endAdornment: (isLoading && jsx("div", { children: jsx(CircularProgress, { id: "loading-indicator", size: 24 }, void 0) }, void 0))
        }, label: 'Search', fullWidth: true }, textFieldProps), void 0));
};

var placeholderMutationHook$2 = function () { return [
    function (args) { },
    {
        isError: false,
        reset: function () { },
        data: undefined,
        isLoading: false,
    },
]; };
var CardListView = function (props) {
    var permissions = useContext(UserPermissionContext).permissions;
    var sortKey = props.sortKey, getDataQuery = props.getDataQuery, _a = props.isShowActiveToggleVisible, isShowActiveToggleVisible = _a === void 0 ? false : _a, inactivateMutation = props.inactivateMutation, activateMutation = props.activateMutation, deleteMutation = props.deleteMutation, entityNameSingular = props.entityNameSingular, _b = props.entityNamePlural, entityNamePlural = _b === void 0 ? entityNameSingular + "s" : _b, permissionName = props.permissionName, handleAdd = props.handleAdd, handleEdit = props.handleEdit, headerTitle = props.headerTitle, _c = props.headerIcon, headerIcon = _c === void 0 ? jsx(Fragment, {}, void 0) : _c, _d = props.breadCrumbs, breadCrumbs = _d === void 0 ? [] : _d, endTitleSlot = props.endTitleSlot, _e = props.additionalQueryParameters, additionalQueryParameters = _e === void 0 ? {} : _e, handleImportClicked = props.handleImportClicked, handleFilterClicked = props.handleFilterClicked, _f = props.filterChips, filterChips = _f === void 0 ? [] : _f, handleFilterChipDelete = props.handleFilterChipDelete, additionalMenuItems = props.additionalMenuItems, additionalActionItems = props.additionalActionItems, renderCard = props.renderCard, currentPageLabel = props.currentPageLabel, stickyPageHeaderHightOffset = props.stickyPageHeaderHightOffset, _g = props.stickyPageHeader, stickyPageHeader = _g === void 0 ? false : _g;
    var _h = useState(null), menuAnchorEl = _h[0], setMenuAnchorEl = _h[1];
    var menuOpen = Boolean(menuAnchorEl);
    var _j = useState(''), searchText = _j[0], setSearchText = _j[1];
    var _k = useState(false), showInactive = _k[0], setShowInactive = _k[1];
    var _l = useState(true), isSortAscending = _l[0], setIsSortAscending = _l[1];
    var _m = getDataQuery(__assign({ searchText: searchText, sortKey: sortKey, sortAsc: isSortAscending, page: 0, pageSize: 1000, includeInactive: showInactive }, additionalQueryParameters)), data = _m.data, isLoading = _m.isLoading, error = _m.error, refetch = _m.refetch, isFetching = _m.isFetching;
    // TODO: this is not currently used in this component and should be removed
    var selected = useState([])[0];
    var defaultIfNotProvided = placeholderMutationHook$2;
    var _o = (inactivateMutation !== null && inactivateMutation !== void 0 ? inactivateMutation : defaultIfNotProvided)(), inactivateRecords = _o[0], _p = _o[1], isInactivateError = _p.isError, resetInactivate = _p.reset, inactivateResult = _p.data, isInactivating = _p.isLoading;
    var _q = (activateMutation !== null && activateMutation !== void 0 ? activateMutation : defaultIfNotProvided)(), activateRecords = _q[0], _r = _q[1], isActivateError = _r.isError, resetActivate = _r.reset, activateResult = _r.data, isActivating = _r.isLoading;
    var _s = (deleteMutation !== null && deleteMutation !== void 0 ? deleteMutation : defaultIfNotProvided)(), deleteRecords = _s[0], _t = _s[1], isDeleteError = _t.isError, resetDelete = _t.reset, deleteResult = _t.data, isDeleting = _t.isLoading;
    useActivateInactivateSnackbar('Inactivate', entityNameSingular, entityNamePlural, inactivateResult, resetInactivate);
    useFailedActionSnackbar('inactivate', entityNamePlural, isInactivateError, resetInactivate);
    useActivateInactivateSnackbar('Activate', entityNameSingular, entityNamePlural, activateResult, resetActivate);
    useFailedActionSnackbar('activate', entityNamePlural, isActivateError, resetActivate);
    useActivateInactivateSnackbar('Delete', entityNameSingular, entityNamePlural, deleteResult, resetDelete);
    useFailedActionSnackbar('delete', entityNamePlural, isDeleteError, resetDelete);
    var handleSearchChange = function (newText) {
        setSearchText(newText);
    };
    var toggleSortOrder = function () {
        setIsSortAscending(!isSortAscending);
    };
    var handleActiveToggleChange = function (event) {
        setShowInactive(event.target.checked);
    };
    var handleMenuOpen = function (event) {
        setMenuAnchorEl(event.currentTarget);
    };
    var handleMenuClose = function (afterClose) { return function () {
        setMenuAnchorEl(null);
        if (afterClose) {
            afterClose();
        }
    }; };
    var handleMenuEdit = function () {
        var selectedRecord = data === null || data === void 0 ? void 0 : data.pageResults[selected[0]];
        if (selectedRecord && handleEdit) {
            handleEdit(selectedRecord.id, selectedRecord);
        }
    };
    var isValidIndex = useCallback(function (index) { return data && data.pageResults.length > index; }, [data]);
    var canSetInactive = useMemo(function () {
        return selected.some(function (index) { return isValidIndex(index) && (data === null || data === void 0 ? void 0 : data.pageResults[index].isActive); });
    }, [selected, isValidIndex, data === null || data === void 0 ? void 0 : data.pageResults]);
    var canSetActive = useMemo(function () {
        return selected.some(function (index) { return isValidIndex(index) && !(data === null || data === void 0 ? void 0 : data.pageResults[index].isActive); });
    }, [selected, isValidIndex, data === null || data === void 0 ? void 0 : data.pageResults]);
    var canDelete = useMemo(function () {
        return selected.some(function (index) { return isValidIndex(index); });
    }, [selected, isValidIndex]);
    var handleSetInactive = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var recordIds;
        return __generator(this, function (_a) {
            if (!data) {
                return [2 /*return*/];
            }
            recordIds = selected
                .map(function (index) { return data.pageResults[index]; })
                .filter(function (record) { return record.isActive; })
                .map(function (record) { return record.id; });
            inactivateRecords(recordIds);
            return [2 /*return*/];
        });
    }); }, [data, inactivateRecords, selected]);
    var handleSetActive = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var recordIds;
        return __generator(this, function (_a) {
            if (!data) {
                return [2 /*return*/];
            }
            recordIds = selected
                .map(function (index) { return data.pageResults[index]; })
                .filter(function (record) { return !record.isActive; })
                .map(function (record) { return record.id; });
            activateRecords(recordIds);
            return [2 /*return*/];
        });
    }); }, [data, activateRecords, selected]);
    var handleDelete = function () { return __awaiter(void 0, void 0, void 0, function () {
        var recordIds;
        return __generator(this, function (_a) {
            if (!data) {
                return [2 /*return*/];
            }
            recordIds = selected.map(function (index) { return data.pageResults[index]; }).map(function (record) { return record.id; });
            deleteRecords(recordIds);
            return [2 /*return*/];
        });
    }); };
    var permittedAdditionalMenuItems = useCallback(function () {
        if (!additionalMenuItems) {
            return [];
        }
        return additionalMenuItems.filter(function (menuItem) { var _a; return userHasPermissions((_a = menuItem.requiredPermissions) !== null && _a !== void 0 ? _a : [], permissions, menuItem.permissionLogic); });
    }, [additionalMenuItems, permissions]);
    var renderAdditionalMenuItems = function () {
        if (permittedAdditionalMenuItems().length === 0) {
            return null;
        }
        var selectedItems = data ? selected.map(function (index) { return data.pageResults[index]; }) : [];
        var menuItems = permittedAdditionalMenuItems().map(function (menuItem) {
            var isEnabled = !menuItem.enabledCheck || menuItem.enabledCheck(selectedItems);
            return (jsx(MenuItem, __assign({ onClick: handleMenuClose(function () { return menuItem.onClick(selectedItems); }), disabled: !isEnabled }, { children: menuItem.text }), void 0));
        });
        return __spreadArrays([jsx(Divider, {}, void 0)], menuItems);
    };
    var permittedAdditionalActionItems = useMemo(function () {
        if (!additionalActionItems) {
            return [];
        }
        return additionalActionItems.filter(function (actionItem) { var _a; return userHasPermissions((_a = actionItem.requiredPermissions) !== null && _a !== void 0 ? _a : [], permissions, actionItem.permissionLogic); });
    }, [additionalActionItems, permissions]);
    var renderAdditionalActionItems = function () {
        if (permittedAdditionalActionItems.length === 0) {
            return null;
        }
        var actionItems = permittedAdditionalActionItems.map(function (actionItem, idx) {
            var isEnabled = !actionItem.enabledCheck || actionItem.enabledCheck([]);
            if (actionItem.buttonIsIconButton) {
                return (jsx(IconButton, __assign({ size: 'medium', onClick: function () {
                        actionItem.onClick([]);
                    }, disabled: !isEnabled }, { children: actionItem.icon }), actionItem.text + "-" + idx));
            }
            else {
                return (jsx(Button, __assign({ color: 'primary', startIcon: actionItem.icon, variant: 'contained', size: 'small', disableElevation: true, onClick: function () {
                        actionItem.onClick([]);
                    }, disabled: !isEnabled, sx: { textTransform: actionItem.preventTextTransform ? 'none' : 'inherit' } }, { children: actionItem.text }), actionItem.text + "-" + idx));
            }
        });
        return actionItems;
    };
    var renderFilterChips = function () {
        if (filterChips.length > 0) {
            return (jsx(Grid, __assign({ item: true, display: 'flex', gap: 1, pb: 2 }, { children: filterChips.map(function (filterChip) {
                    var _a;
                    return (jsx(Chip, { label: "" + filterChip.key + ((_a = filterChip.separator) !== null && _a !== void 0 ? _a : ':') + " " + filterChip.text, color: 'primary', onDelete: handleFilterChipDelete ? function () { return handleFilterChipDelete(filterChip.key); } : undefined }, filterChip.key));
                }) }), void 0));
        }
        return null;
    };
    var ActivateInactivateButton = useMemo(function () {
        var areMixedRecordsSelected = canSetActive && canSetInactive;
        if (canSetActive && !canSetInactive) {
            return (jsx(Tooltip, __assign({ title: 'Make Active' }, { children: jsx("span", { children: jsx(IconButton, __assign({ size: 'large', onClick: handleSetActive, disabled: isActivating }, { children: jsx(Unarchive, { fontSize: 'inherit' }, void 0) }), void 0) }, void 0) }), void 0));
        }
        else {
            return (jsx(Tooltip, __assign({ title: areMixedRecordsSelected ? 'Cannot Activate or Inactivate records when both active and inactive records are selected' : 'Make Inactive' }, { children: jsx("span", { children: jsx(IconButton, __assign({ size: 'large', onClick: handleSetInactive, disabled: !canSetInactive || areMixedRecordsSelected || isInactivating }, { children: jsx(Archive, { fontSize: 'inherit' }, void 0) }), void 0) }, void 0) }), void 0));
        }
    }, [canSetActive, canSetInactive, handleSetActive, isActivating, handleSetInactive, isInactivating]);
    var renderHeaderActions = function () { return (jsx(Grid, __assign({ item: true, container: true, direction: 'row', alignItems: 'start', py: 1 }, { children: jsxs(Grid, __assign({ item: true, display: 'flex', alignItems: 'center', justifyContent: 'end', xs: 12, sx: { gap: 1 }, pr: 2 }, { children: [renderAdditionalActionItems(), jsx(Divider, { flexItem: true, orientation: 'vertical', sx: { mx: 1 } }, void 0),
                jsx("div", { children: jsx(StandardSearchInput, { searchText: searchText, handleSearchChange: handleSearchChange, isLoading: isFetching, textFieldProps: {
                            size: 'small',
                            variant: 'standard',
                            label: undefined,
                        } }, void 0) }, void 0),
                jsx(Divider, { flexItem: true, orientation: 'vertical', sx: { ml: 1, mr: isShowActiveToggleVisible ? 0 : 1 } }, void 0),
                isShowActiveToggleVisible && (jsx(FormControlLabel, { control: jsx(Switch, { checked: showInactive, onChange: handleActiveToggleChange, size: 'small' }, void 0), label: 'Show Inactive', labelPlacement: 'start' }, void 0)),
                inactivateMutation && activateMutation && (jsx(AuthenticatedComponent, { requiredPermissions: ["inactivate:" + permissionName], children: ActivateInactivateButton }, void 0)),
                deleteMutation && (jsx(AuthenticatedComponent, __assign({ requiredPermissions: ["delete:" + permissionName] }, { children: jsx(Tooltip, __assign({ title: 'Delete' }, { children: jsx("span", { children: jsx(IconButton, __assign({ size: 'large', onClick: handleDelete, disabled: !canDelete || isDeleting }, { children: jsx(Delete, { fontSize: 'inherit' }, void 0) }), void 0) }, void 0) }), void 0) }), void 0)),
                jsx(Tooltip, __assign({ title: 'Sort' }, { children: jsx("span", { children: jsx(IconButton, __assign({ size: 'large', onClick: toggleSortOrder }, { children: jsx(SortByAlpha, { fontSize: 'inherit' }, void 0) }), void 0) }, void 0) }), void 0),
                handleFilterClicked && (jsx(Tooltip, __assign({ title: 'Filter' }, { children: jsx("span", { children: jsx(IconButton, __assign({ size: 'large', onClick: handleFilterClicked, color: 'primary' }, { children: jsx(FilterList, { fontSize: 'inherit' }, void 0) }), void 0) }, void 0) }), void 0)),
                handleImportClicked && (jsx(AuthenticatedComponent, __assign({ requiredPermissions: ["create:" + permissionName] }, { children: jsx(Tooltip, __assign({ title: 'Import' }, { children: jsx("span", { children: jsx(IconButton, __assign({ size: 'large', onClick: handleImportClicked }, { children: jsx(UploadFile, { fontSize: 'inherit' }, void 0) }), void 0) }, void 0) }), void 0) }), void 0)),
                jsx(Divider, { flexItem: true, orientation: 'vertical', sx: { mx: 1 } }, void 0),
                handleAdd && (jsx(AuthenticatedComponent, __assign({ requiredPermissions: ["create:" + permissionName] }, { children: jsx(Tooltip, __assign({ title: 'Add New' }, { children: jsx(Button, __assign({ color: 'primary', startIcon: jsx(AddCircle, {}, void 0), variant: 'contained', size: 'small', disableElevation: true, onClick: handleAdd }, { children: "Add New" }), void 0) }), void 0) }), void 0)),
                jsxs(AuthenticatedComponent, __assign({ requiredPermissions: permittedAdditionalMenuItems().length > 0
                        ? []
                        : ["create:" + permissionName, "edit:" + permissionName, "delete:" + permissionName, "inactivate:" + permissionName], logic: 'or' }, { children: [jsx(IconButton, __assign({ onClick: handleMenuOpen }, { children: jsx(MoreVert, { fontSize: 'inherit' }, void 0) }), void 0),
                        jsxs(Menu, __assign({ anchorEl: menuAnchorEl, open: menuOpen, onClose: handleMenuClose(), anchorOrigin: {
                                vertical: 'bottom',
                                horizontal: 'center',
                            }, transformOrigin: {
                                vertical: 'top',
                                horizontal: 'right',
                            } }, { children: [handleAdd && (jsx(AuthenticatedComponent, __assign({ requiredPermissions: ["create:" + permissionName] }, { children: jsx(MenuItem, __assign({ onClick: handleMenuClose(handleAdd) }, { children: "Add New" }), void 0) }), void 0)),
                                handleEdit && (jsx(AuthenticatedComponent, __assign({ requiredPermissions: ["edit:" + permissionName] }, { children: jsx(MenuItem, __assign({ onClick: handleMenuClose(handleMenuEdit), disabled: selected.length !== 1 }, { children: "Edit" }), void 0) }), void 0)),
                                handleImportClicked && (jsx(AuthenticatedComponent, __assign({ requiredPermissions: ["create:" + permissionName] }, { children: jsx(MenuItem, __assign({ onClick: handleMenuClose(handleImportClicked) }, { children: "Import" }), void 0) }), void 0)),
                                (activateMutation || inactivateMutation || deleteMutation) && (jsx(AuthenticatedComponent, { requiredPermissions: ["inactivate:" + permissionName, "delete:" + permissionName], logic: 'or', children: jsx(Divider, {}, void 0) }, void 0)),
                                activateMutation && (jsx(AuthenticatedComponent, __assign({ requiredPermissions: ["inactivate:" + permissionName] }, { children: jsx(MenuItem, __assign({ onClick: handleMenuClose(handleSetActive), disabled: !canSetActive || isActivating }, { children: "Make Active" }), void 0) }), void 0)),
                                inactivateMutation && (jsx(AuthenticatedComponent, __assign({ requiredPermissions: ["inactivate:" + permissionName] }, { children: jsx(MenuItem, __assign({ onClick: handleMenuClose(handleSetInactive), disabled: !canSetInactive || isInactivating }, { children: "Make Inactive" }), void 0) }), void 0)),
                                deleteMutation && (jsx(AuthenticatedComponent, __assign({ requiredPermissions: ["delete:" + permissionName] }, { children: jsx(MenuItem, __assign({ onClick: handleMenuClose(handleDelete), disabled: !canDelete || isDeleting }, { children: "Delete" }), void 0) }), void 0)), renderAdditionalMenuItems()] }), void 0)] }), void 0)] }), void 0) }), void 0)); };
    var stickyPageHeaderHeightCalc = useMemo(function () {
        if (stickyPageHeaderHightOffset) {
            return "calc(100vh - " + stickyPageHeaderHightOffset + "px)";
        }
        else {
            return 'calc(100vh)';
        }
    }, [stickyPageHeaderHightOffset]);
    if (isLoading) {
        return jsx(LoadingIndicator, {}, void 0);
    }
    if (error) {
        return jsx(ApiError, { onReloadClick: refetch }, void 0);
    }
    return (jsxs(Grid, __assign({ container: true, direction: 'column' }, { children: [jsx(SlimPageHeader, { icon: headerIcon, title: headerTitle, breadCrumbProps: breadCrumbs.length > 0
                    ? {
                        links: breadCrumbs !== null && breadCrumbs !== void 0 ? breadCrumbs : [],
                        currentPageLabel: currentPageLabel !== null && currentPageLabel !== void 0 ? currentPageLabel : entityNamePlural,
                    }
                    : undefined, endTitleSlot: endTitleSlot, endSlot: renderHeaderActions() }, void 0), renderFilterChips(), jsxs(Grid, __assign({ item: true, container: true, direction: 'row', px: 2, pt: 2, sx: stickyPageHeader ? { maxHeight: stickyPageHeaderHeightCalc, overflow: 'auto' } : {} }, { children: [data === null || data === void 0 ? void 0 : data.pageResults.map(function (item, index) { return (jsx(Grid, __assign({ item: true, xs: 12, sm: 6, md: 4, lg: 3, height: 196, padding: 2, overflow: 'hidden' }, { children: renderCard(item) }), index)); }), jsx(AuthenticatedComponent, __assign({ requiredPermissions: ["create:" + permissionName] }, { children: jsx(Grid, __assign({ item: true, xs: 12, sm: 6, md: 4, lg: 3, height: 196, padding: 2 }, { children: jsxs(Box, __assign({ onClick: handleAdd, width: '100%', height: '100%', border: '2px dashed #333333', display: 'flex', flexDirection: 'column', justifyContent: 'start', alignItems: 'center', sx: { cursor: 'pointer' } }, { children: [jsx("div", __assign({ style: { fontSize: 72, height: 72, marginBottom: 8, marginTop: 24 } }, { children: jsx(AddCircle, { color: 'primary', fontSize: 'inherit' }, void 0) }), void 0), "Add New ", entityNameSingular] }), void 0) }), void 0) }), void 0)] }), void 0)] }), void 0));
};

var PaginationActions = function (props) {
    var count = props.count, page = props.page, rowsPerPage = props.rowsPerPage, onPageChange = props.onPageChange;
    var handleFirstPageButtonClick = function (event) {
        onPageChange(event, 0);
    };
    var handleBackButtonClick = function (event) {
        onPageChange(event, page - 1);
    };
    var handleNextButtonClick = function (event) {
        onPageChange(event, page + 1);
    };
    var handleLastPageButtonClick = function (event) {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };
    return (jsxs(Box, __assign({ sx: { flexShrink: 0, ml: 2.5 } }, { children: [jsx(IconButton, __assign({ onClick: handleFirstPageButtonClick, disabled: page === 0, "aria-label": "first page" }, { children: jsx(FirstPage, {}, void 0) }), void 0),
            jsx(IconButton, __assign({ onClick: handleBackButtonClick, disabled: page === 0, "aria-label": "previous page" }, { children: jsx(KeyboardArrowLeft, {}, void 0) }), void 0),
            jsx(IconButton, __assign({ onClick: handleNextButtonClick, disabled: page >= Math.ceil(count / rowsPerPage) - 1, "aria-label": "next page" }, { children: jsx(KeyboardArrowRight, {}, void 0) }), void 0),
            jsx(IconButton, __assign({ onClick: handleLastPageButtonClick, disabled: page >= Math.ceil(count / rowsPerPage) - 1, "aria-label": "last page" }, { children: jsx(LastPage, {}, void 0) }), void 0)] }), void 0));
};

var PaginatedDataTable = function (props) {
    var _a;
    var _b = props.columnGroups, columnGroups = _b === void 0 ? [] : _b, columns = props.columns, defaultSortKey = props.defaultSortKey, defaultSortDesc = props.defaultSortDesc, defaultSorting = props.defaultSorting, _c = props.defaultPage, defaultPage = _c === void 0 ? 0 : _c, _d = props.defaultPageSize, defaultPageSize = _d === void 0 ? 25 : _d, queryResults = props.queryResults, loading = props.loading, setPagination = props.setPagination, _e = props.selectedRecords, selectedRecords = _e === void 0 ? [] : _e, setSelectedRecords = props.setSelectedRecords, isViewOnly = props.isViewOnly, _f = props.editPermissions, editPermissions = _f === void 0 ? { requiredPermissions: [], logic: 'and' } : _f, onEdit = props.onEdit, onRowClick = props.onRowClick, onHover = props.onHover, isDashboardStyle = props.isDashboardStyle, _g = props.isDense, isDense = _g === void 0 ? false : _g, _h = props.isInactiveStyleApplied, isInactiveStyleApplied = _h === void 0 ? true : _h, _j = props.isBorderVisible, isBorderVisible = _j === void 0 ? true : _j, _k = props.editToolTip, editToolTip = _k === void 0 ? 'Edit' : _k, _l = props.customRowStyling, customRowStyling = _l === void 0 ? function (row) {
        return {};
    } : _l, _m = props.isPaginationVisible, isPaginationVisible = _m === void 0 ? true : _m, _o = props.isRowsPerPageChangeable, isRowsPerPageChangeable = _o === void 0 ? true : _o, _p = props.editIcon, editIcon = _p === void 0 ? (jsx(Edit, { sx: {
            fontSize: isDashboardStyle ? '16px' : '22px',
        } }, void 0)) : _p, _q = props.isHeaderVisible, isHeaderVisible = _q === void 0 ? true : _q, _r = props.noDataMessage, noDataMessage = _r === void 0 ? 'No results found.' : _r, _s = props.disableEditForInactive, disableEditForInactive = _s === void 0 ? false : _s, _t = props.showExtendedPaginationOptions, showExtendedPaginationOptions = _t === void 0 ? true : _t, _u = props.stickyHeader, stickyHeader = _u === void 0 ? false : _u, maxTableHeight = props.maxTableHeight, _v = props.enableMultiSort, enableMultiSort = _v === void 0 ? false : _v, _w = props.paginationOnTop, paginationOnTop = _w === void 0 ? false : _w, tableControlsSlot = props.tableControlsSlot, _refNumSfx = props.referenceNumberColumnKeySuffixes, referenceNumberColumnKeySuffixes = _refNumSfx === void 0 ? {} : _refNumSfx;
    var theme = useTheme();
    var paginationRowRef = useRef(null);
    var _x = useState(0), paginationRowHeight = _x[0], setPaginationRowHeight = _x[1];
    // Measures and tracks the pagination row height when it's positioned on top,
    // updating on resize and layout changes. This is necessary to position the sticky header correctly.
    useEffect(function () {
        if (paginationOnTop && isPaginationVisible && paginationRowRef.current) {
            var updateHeight_1 = function () {
                if (paginationRowRef.current) {
                    setPaginationRowHeight(paginationRowRef.current.offsetHeight);
                }
            };
            updateHeight_1();
            window.addEventListener('resize', updateHeight_1);
            var timeoutId_1 = setTimeout(updateHeight_1, 100);
            return function () {
                window.removeEventListener('resize', updateHeight_1);
                clearTimeout(timeoutId_1);
            };
        }
        else {
            setPaginationRowHeight(0);
        }
    }, [paginationOnTop, loading, isPaginationVisible]);
    var defaultSortValue = useMemo(function () {
        if (defaultSortDesc === undefined || defaultSortDesc === null) {
            return 'asc';
        }
        return defaultSortDesc ? 'desc' : 'asc';
    }, [defaultSortDesc]);
    // Initialize sort items based on multi-sort mode
    var initialSortItems = useMemo(function () {
        if (defaultSorting) {
            return defaultSorting;
        }
        if (defaultSortKey) {
            return [{ key: defaultSortKey, direction: defaultSortValue }];
        }
        return [];
    }, [defaultSortKey, defaultSortValue, defaultSorting]);
    var _y = useState(initialSortItems), sortItems = _y[0], setSortItems = _y[1];
    var _z = useState(defaultPage), page = _z[0], setPage = _z[1];
    var _0 = useState(defaultPageSize), pageSize = _0[0], setPageSize = _0[1];
    useEffect(function () {
        var _a;
        if (sortItems.length > 0) {
            var firstSort = sortItems[0];
            var paginationProps = {
                sortKey: (_a = firstSort === null || firstSort === void 0 ? void 0 : firstSort.key) !== null && _a !== void 0 ? _a : '',
                sortAsc: (firstSort === null || firstSort === void 0 ? void 0 : firstSort.direction) === 'asc',
                sorting: sortItems,
                page: page,
                pageSize: pageSize,
            };
            setPagination(paginationProps);
        }
        else {
            setPagination({
                sortKey: '',
                sortAsc: true,
                sorting: [],
                page: page,
                pageSize: pageSize,
            });
        }
    }, [sortItems, page, pageSize, setPagination]);
    useEffect(function () {
        var _a;
        var totalPages = ((_a = queryResults === null || queryResults === void 0 ? void 0 : queryResults.totalQueryResults) !== null && _a !== void 0 ? _a : 0.0) / pageSize;
        if (page > totalPages) {
            setPage(0);
        }
    }, [page, pageSize, queryResults]);
    var shouldShowEditColumn = !!onEdit && !!editPermissions;
    var shouldShowCheckboxes = !isDashboardStyle && !!setSelectedRecords;
    var isEndOfColumnGroup = function (headerIndex) {
        var columnGroupEndingIndexes = columnGroups.map(function (cg) { return cg.colSpan; });
        if (columnGroupEndingIndexes.length >= 2) {
            for (var index = 1; index < columnGroupEndingIndexes.length; index++) {
                columnGroupEndingIndexes[index] += columnGroupEndingIndexes[index - 1];
            }
        }
        return columnGroupEndingIndexes.includes(headerIndex + 1);
    };
    var handleRequestSort = function (sortKey) { return function (_) {
        if (enableMultiSort) {
            // Multi-sort mode
            setSortItems(function (prevItems) {
                var existingIndex = prevItems.findIndex(function (item) { return item.key === sortKey; });
                if (existingIndex >= 0) {
                    // Toggle existing sort between asc and desc
                    var existingItem = prevItems[existingIndex];
                    var newDirection = existingItem.direction === 'asc' ? 'desc' : 'asc';
                    var newItems = __spreadArrays(prevItems);
                    newItems[existingIndex] = { key: sortKey, direction: newDirection };
                    return newItems;
                }
                else {
                    // Add new sort as ascending
                    return __spreadArrays(prevItems, [{ key: sortKey, direction: 'asc' }]);
                }
            });
        }
        else {
            // Single-sort mode (backward compatible)
            setSortItems(function (prevItems) {
                if (prevItems.length > 0) {
                    var firstItem = prevItems[0];
                    if ((firstItem === null || firstItem === void 0 ? void 0 : firstItem.key) === sortKey) {
                        // Toggle direction
                        var newDirection = firstItem.direction === 'asc' ? 'desc' : 'asc';
                        return [{ key: sortKey, direction: newDirection }];
                    }
                    else {
                        // New sort key
                        return [{ key: sortKey, direction: 'asc' }];
                    }
                }
                else {
                    return [{ key: sortKey, direction: 'asc' }];
                }
            });
        }
    }; };
    var handleRemoveSort = function (sortKey) { return function (event) {
        event.stopPropagation();
        event.preventDefault();
        setSortItems(function (prevItems) { return prevItems.filter(function (item) { return item.key !== sortKey; }); });
    }; };
    var handleChangePage = function (_, newPage) {
        setPage(newPage);
    };
    var handleChangeRowsPerPage = function (event) {
        setPageSize(parseInt(event.target.value, 10));
        setPage(0);
    };
    var handleSelectAllClick = function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (!setSelectedRecords) {
            return;
        }
        var currentPageRecords = queryResults.pageResults;
        if (event.target.checked) {
            setSelectedRecords(_.uniqBy(__spreadArrays(selectedRecords, currentPageRecords), function (record) { return record.id; }));
        }
        else {
            setSelectedRecords(_.differenceBy(selectedRecords, currentPageRecords, function (record) { return record.id; }));
        }
    };
    var handleSelectClick = function (event, record) {
        event.preventDefault();
        event.stopPropagation();
        if (!setSelectedRecords) {
            return;
        }
        var isCurrentlySelected = selectedRecords.some(function (selectedRecord) { return selectedRecord.id === record.id; });
        if (isCurrentlySelected) {
            setSelectedRecords(selectedRecords.filter(function (selectedRecord) { return selectedRecord.id !== record.id; }));
        }
        else {
            setSelectedRecords(__spreadArrays(selectedRecords, [record]));
        }
    };
    var handleRowOnMouseEnter = function (id) {
        if (onHover) {
            onHover(id);
        }
    };
    var handleRowOnMouseLeave = function (id) {
        if (onHover) {
            onHover('');
        }
    };
    var handleRowClick = function (event, row) {
        event.preventDefault();
        event.stopPropagation();
        if (onRowClick) {
            onRowClick(row.id, row);
        }
        else {
            handleSelectClick(event, row);
        }
    };
    var getHeaderText = function (header) {
        var _a;
        if (header.shouldPullHeaderFromData) {
            var results = (_a = queryResults === null || queryResults === void 0 ? void 0 : queryResults.pageResults) !== null && _a !== void 0 ? _a : [];
            if (results.length === 0) {
                return '-';
            }
            var firstResult = results[0];
            return firstResult[header.label] || '-';
        }
        else {
            return header.label;
        }
    };
    var renderHeaders = function () {
        return columns.map(function (header, index) {
            var _a;
            var isFirstColumn = index === 0 && !shouldShowCheckboxes;
            var isLastColumn = index === columns.length - 1 && !shouldShowEditColumn;
            var shouldShowBorder = isEndOfColumnGroup(index) && !isLastColumn;
            var shouldAddPaddingLeft = isFirstColumn || isEndOfColumnGroup(index - 1);
            // Find sort info for this column
            var sortIndex = sortItems.findIndex(function (item) { return item.key === header.sortKey; });
            var sortItem = sortIndex >= 0 ? sortItems[sortIndex] : null;
            var isActive = sortItem !== null;
            var direction = (_a = sortItem === null || sortItem === void 0 ? void 0 : sortItem.direction) !== null && _a !== void 0 ? _a : 'asc';
            return (jsx(TableCell, __assign({ align: header.align, sx: {
                    fontSize: isDashboardStyle ? '12px' : '',
                    lineHeight: isDashboardStyle ? '12px' : '14px',
                    width: header.width ? header.width : 'auto',
                    minWidth: header.width ? header.width : 'auto',
                    maxWidth: header.width ? header.width : 'auto',
                    verticalAlign: 'bottom',
                    py: isDense ? 0.5 : 1,
                    pl: shouldAddPaddingLeft ? 1 : 0,
                    pr: 1,
                    borderRight: shouldShowBorder ? '1px solid lightGrey' : 'none',
                    backgroundColor: 'background.paper',
                } }, { children: !header.unsorted ? (jsx("div", __assign({ style: { position: 'relative', display: 'flex', alignItems: 'center', gap: '4px' } }, { children: jsxs(TableSortLabel, __assign({ active: isActive, direction: direction, onClick: handleRequestSort(header.sortKey), sx: { px: 0, mx: 0 } }, { children: [getHeaderText(header), enableMultiSort && isActive && (jsx(Tooltip, __assign({ title: 'Remove sort' }, { children: jsxs("div", __assign({ onClick: handleRemoveSort(header.sortKey), style: {
                                        marginLeft: '4px',
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        gap: '2px',
                                        backgroundColor: theme.palette.primary.main,
                                        color: 'white',
                                        borderRadius: '12px',
                                        padding: '2px 6px',
                                        fontSize: '12px',
                                        fontWeight: 500,
                                        cursor: 'pointer',
                                        flexShrink: 0,
                                        minWidth: 'fit-content',
                                    } }, { children: [jsx("span", { children: sortIndex + 1 }, void 0),
                                        jsx(Close, { sx: { fontSize: '14px' } }, void 0)] }), void 0) }), void 0))] }), void 0) }), void 0)) : (jsx("div", __assign({ style: { paddingBottom: '3px' } }, { children: getHeaderText(header) }), void 0)) }), header.key));
        });
    };
    var renderFields = function (row, rowIdx) {
        return columns.map(function (header, index) {
            var field = null;
            var keySuffix = header.key.split('.').pop();
            var skipLocaleNumberFormat = referenceNumberColumnKeySuffixes[keySuffix] === true;
            if (header.fieldMapper) {
                field = header.fieldMapper(row);
            }
            else {
                var accessors = header.key.split('.');
                field = row;
                accessors.forEach(function (key) {
                    field = field[key];
                });
                if (header.keyFieldFormatter) {
                    field = header.keyFieldFormatter(field);
                }
                else {
                    if (!skipLocaleNumberFormat && Number.isSafeInteger(field)) {
                        field = Number.parseInt(field).toLocaleString();
                    }
                }
            }
            if (!skipLocaleNumberFormat && typeof field === 'number') {
                field = field.toLocaleString();
            }
            if (typeof field === 'string') {
                field = (jsx(Tooltip, __assign({ title: field, followCursor: true }, { children: jsx("div", __assign({ style: { textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' } }, { children: field }), void 0) }), void 0));
            }
            var isFirstColumn = index === 0 && !shouldShowCheckboxes;
            var shouldAddPaddingLeft = isFirstColumn || isEndOfColumnGroup(index - 1);
            return (jsx(TableCell, __assign({ onClick: function (event) { return handleRowClick(event, row); }, align: header.align, size: isDashboardStyle || isDense ? 'small' : 'medium', sx: __assign(__assign({}, (row.isActive === true || !isInactiveStyleApplied
                    ? {
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        px: 0,
                    }
                    : {
                        color: '#AAAAAA',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                    })), { fontSize: isDashboardStyle ? '12px' : '', lineHeight: isDashboardStyle ? '12px' : '14px', textOverflow: 'ellipsis', width: header.width ? header.width : 'auto', minWidth: header.width ? header.width : 'auto', maxWidth: header.width ? header.width : 'auto', pl: shouldAddPaddingLeft ? 1 : 0, pr: 1, py: isDashboardStyle || isDense ? 0.2 : 1 }) }, { children: field }), header.key));
        });
    };
    var isSelected = function (recordId) { return selectedRecords.some(function (selectedRecord) { return selectedRecord.id === recordId; }); };
    var rowCount = queryResults ? queryResults.pageResults.length : 0;
    var totalCols = columns.length + (shouldShowCheckboxes ? 1 : 0) + (shouldShowEditColumn ? 1 : 0);
    var totalResults = (_a = queryResults === null || queryResults === void 0 ? void 0 : queryResults.totalQueryResults) !== null && _a !== void 0 ? _a : 0;
    var renderPaginationControls = function (colSpanOverride) {
        if (!isPaginationVisible || isDashboardStyle) {
            return null;
        }
        var paginationColSpan = colSpanOverride !== null && colSpanOverride !== void 0 ? colSpanOverride : totalCols;
        return (jsx(Box, __assign({ sx: { display: 'flex', justifyContent: 'flex-end', width: '100%' } }, { children: jsx(TablePagination, { colSpan: paginationColSpan, rowsPerPageOptions: isRowsPerPageChangeable ? [25, 50, 100] : [], count: totalResults, ActionsComponent: showExtendedPaginationOptions ? PaginationActions : undefined, rowsPerPage: pageSize, page: page, onPageChange: handleChangePage, onRowsPerPageChange: isRowsPerPageChangeable ? handleChangeRowsPerPage : undefined, sx: { border: 'none', display: 'flex', justifyContent: 'flex-end', backgroundColor: 'background.paper' } }, void 0) }), void 0));
    };
    return (jsxs(Paper, __assign({ elevation: 0, sx: {
            border: isDashboardStyle || !isBorderVisible ? '' : 'solid 1px #AAAAAA',
            width: '100%',
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            height: paginationOnTop ? '100%' : 'auto',
            flex: paginationOnTop ? 1 : 'none',
        } }, { children: [jsx(TableContainer, __assign({ sx: __assign(__assign(__assign({}, (paginationOnTop
                    ? { flex: 1, minHeight: 0, height: '100%' }
                    : { height: '100%' })), { overflowY: 'auto', overflowX: 'auto' }), (maxTableHeight ? { maxHeight: maxTableHeight } : {})) }, { children: jsxs(Table, __assign({ stickyHeader: stickyHeader, sx: { minHeight: '24px' } }, { children: [paginationOnTop && isPaginationVisible && (jsx(TableHead, __assign({ ref: paginationRowRef, sx: stickyHeader
                                ? { position: 'sticky', top: 0, zIndex: 1100 }
                                : {} }, { children: jsx(TableRow, { children: jsx(TableCell, __assign({ colSpan: totalCols, sx: { padding: '8px 16px', borderBottom: 'none', backgroundColor: 'background.paper' } }, { children: jsxs(Box, __assign({ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }, { children: [tableControlsSlot, jsx(Box, __assign({ display: 'flex', alignItems: 'center', whiteSpace: 'nowrap' }, { children: renderPaginationControls(totalCols) }), void 0)] }), void 0) }), void 0) }, void 0) }), void 0)),
                        isHeaderVisible && (jsxs(TableHead, __assign({ sx: stickyHeader
                                ? {
                                    position: 'sticky',
                                    top: paginationOnTop && isPaginationVisible && paginationRowHeight > 0
                                        ? paginationRowHeight
                                        : 0,
                                    zIndex: 1099,
                                } : {} }, { children: [columnGroups && columnGroups.length > 0 && (jsxs(TableRow, { children: [shouldShowCheckboxes && jsx(TableCell, { sx: { py: isDense ? 0.5 : 1 } }, void 0),
                                        columnGroups.map(function (columnGroup, index) { return (jsx(TableCell, __assign({ colSpan: columnGroup.colSpan, sx: {
                                                textAlign: 'center',
                                                borderRight: index !== columnGroups.length - 1 ? '1px solid lightGrey' : 'none',
                                                fontSize: isDashboardStyle ? '12px' : '',
                                                lineHeight: isDashboardStyle ? '12px' : '14px',
                                                py: isDense ? 0.5 : 1,
                                                px: 0,
                                                verticalAlign: 'bottom',
                                                backgroundColor: columnGroup.backgroundColor,
                                                color: columnGroup.textColor,
                                            } }, { children: columnGroup.label }), "table-group-header-" + index)); })] }, void 0)),
                                jsxs(TableRow, { children: [shouldShowCheckboxes && (jsx(TableCell, __assign({ padding: 'checkbox', sx: { py: 0, backgroundColor: 'background.paper' } }, { children: jsx(Checkbox, { color: 'primary', indeterminate: selectedRecords.length > 0 && selectedRecords.length < rowCount, checked: rowCount > 0 && selectedRecords.length === rowCount, onChange: handleSelectAllClick, sx: { py: isDense ? 0 : undefined } }, void 0) }), void 0)), renderHeaders(), shouldShowEditColumn && (jsx(AuthenticatedComponent, { requiredPermissions: editPermissions.requiredPermissions, logic: editPermissions.logic, children: jsx(TableCell, { padding: 'checkbox', sx: { backgroundColor: 'background.paper' } }, void 0) }, void 0))] }, void 0)] }), void 0)),
                        jsxs(TableBody, { children: [queryResults && queryResults.pageResults.length > 0 ? (queryResults.pageResults.map(function (row, index) {
                                    var isItemSelected = isSelected(row.id);
                                    return (jsxs(TableRow, __assign({ hover: true, onMouseEnter: function () { return handleRowOnMouseEnter(row.id); }, onMouseLeave: function () { return handleRowOnMouseLeave(row.id); }, role: 'checkbox', selected: isItemSelected, tabIndex: -1, sx: customRowStyling(row), className: 'hover-content-container' }, { children: [shouldShowCheckboxes && (jsx(TableCell, __assign({ padding: 'checkbox', sx: {
                                                    borderLeft: row.isActive || !isInactiveStyleApplied ? undefined : '#AAAAAA 10px solid',
                                                } }, { children: jsx(Checkbox, { onClick: function (event) { return handleSelectClick(event, row); }, color: 'primary', sx: {
                                                        marginLeft: row.isActive || !isInactiveStyleApplied ? undefined : '-5px',
                                                        py: isDense ? 0 : undefined,
                                                    }, checked: isItemSelected }, void 0) }), void 0)), renderFields(row), shouldShowEditColumn && (jsxs(AuthenticatedComponent, __assign({ requiredPermissions: editPermissions.requiredPermissions, logic: editPermissions.logic }, { children: [(!disableEditForInactive || row.isActive) && (jsx(Tooltip, __assign({ title: isViewOnly && !editToolTip ? 'View' : editToolTip }, { children: jsx(TableCell, __assign({ padding: 'none' }, { children: jsx(IconButton, __assign({ size: 'small', className: 'hover-content', onClick: function (e) {
                                                                    e.stopPropagation();
                                                                    e.preventDefault();
                                                                    onEdit(row.id, row, e);
                                                                } }, { children: isViewOnly ? jsx(Visibility, {}, void 0) : editIcon }), void 0) }), void 0) }), void 0)),
                                                    disableEditForInactive && !row.isActive && jsx(TableCell, { padding: 'none' }, void 0)] }), void 0))] }), row.id));
                                })) : (jsx(TableRow, { children: jsx(TableCell, __assign({ align: 'center', colSpan: columns.length + 1 + (onEdit ? 1 : 0) }, { children: noDataMessage }), void 0) }, void 0)),
                                loading && (jsx(TableRow, { children: jsx(TableCell, __assign({ colSpan: columns.length + 1, style: {
                                            position: 'absolute',
                                            top: '0px',
                                            width: '100%',
                                            height: '100%',
                                            background: 'rgba(0,0,0,0.1)',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'center',
                                            paddingTop: '32px',
                                        } }, { children: jsx(LoadingIndicator, {}, void 0) }), void 0) }, void 0))] }, void 0)] }), void 0) }), void 0),
            !loading && !isDashboardStyle && isPaginationVisible && !paginationOnTop && (jsx(Table, { children: jsx(TableFooter, { children: jsx(TableRow, { children: renderPaginationControls() }, void 0) }, void 0) }, void 0))] }), void 0));
};

// TODO: this should be moved into the core library eventually but since it is still rapidly changing for this project I am leaving it here for now
var MobileListView = function (_a) {
    var _b, _c, _d, _e, _f;
    var _g = _a.additionalQueryParameters, additionalQueryParameters = _g === void 0 ? {} : _g, customRowStyling = _a.customRowStyling, defaultPaginationProps = _a.defaultPaginationProps, getDataQuery = _a.getDataQuery, handleEdit = _a.handleEdit, handleRowClick = _a.handleRowClick, headerIcon = _a.headerIcon, _h = _a.headerTitle, headerTitle = _h === void 0 ? "" : _h, hideSearch = _a.hideSearch, noDataMessage = _a.noDataMessage, onNoDataLoaded = _a.onNoDataLoaded, permissionName = _a.permissionName, tableColumns = _a.tableColumns, fixedPageSize = _a.fixedPageSize, showInactiveStyling = _a.showInactiveStyling, referenceNumberColumnKeySuffixes = _a.referenceNumberColumnKeySuffixes;
    var _j = useState(''), searchText = _j[0], setSearchText = _j[1];
    var _k = useState(defaultPaginationProps), paginatedProps = _k[0], setPaginatedProps = _k[1];
    var _l = getDataQuery(__assign({ searchText: searchText, sortKey: (_b = paginatedProps === null || paginatedProps === void 0 ? void 0 : paginatedProps.sortKey) !== null && _b !== void 0 ? _b : '', sortAsc: (_c = paginatedProps === null || paginatedProps === void 0 ? void 0 : paginatedProps.sortAsc) !== null && _c !== void 0 ? _c : true, page: (_d = paginatedProps === null || paginatedProps === void 0 ? void 0 : paginatedProps.page) !== null && _d !== void 0 ? _d : 0, pageSize: fixedPageSize !== undefined ? fixedPageSize : ((_e = paginatedProps === null || paginatedProps === void 0 ? void 0 : paginatedProps.pageSize) !== null && _e !== void 0 ? _e : 25), includeInactive: false }, additionalQueryParameters)), data = _l.data, isSuccess = _l.isSuccess, isLoading = _l.isLoading, error = _l.error, refetch = _l.refetch, isFetching = _l.isFetching;
    useEffect(function () {
        if (onNoDataLoaded) {
            if (!isLoading && !isFetching && isSuccess && data && data.totalQueryResults === 0) {
                onNoDataLoaded();
            }
        }
    }, [data, isFetching, isLoading, isSuccess, onNoDataLoaded]);
    var handleSearchChange = useCallback(function (newText) { return setSearchText(newText); }, []);
    var isHeaderVisible = useMemo(function () { return headerIcon || headerTitle; }, [headerIcon, headerTitle]);
    if (isLoading) {
        return jsx(LoadingIndicator, {}, void 0);
    }
    if (error) {
        return jsx(ApiError, { onReloadClick: refetch }, void 0);
    }
    return (jsx(Paper, { children: jsxs(Grid, __assign({ container: true, direction: 'column', rowGap: 2 }, { children: [isHeaderVisible && jsx(Grid, __assign({ item: true, bgcolor: 'primary.main', color: 'primary.contrastText' }, { children: jsxs(Toolbar, { children: [headerIcon, jsx(Typography, __assign({ variant: 'h2', ml: 1 }, { children: headerTitle }), void 0)] }, void 0) }), void 0),
                !hideSearch && (jsx(Grid, __assign({ item: true, px: 2, pt: isHeaderVisible ? undefined : 2 }, { children: jsx(StandardSearchInput, { searchText: searchText, handleSearchChange: handleSearchChange, isLoading: isFetching, textFieldProps: {
                            size: 'small',
                            variant: 'outlined',
                            label: undefined,
                            placeholder: 'Search'
                        } }, void 0) }), void 0)),
                jsx(Grid, __assign({ item: true, xs: 12, width: '100%' }, { children: jsx(PaginatedDataTable, { columns: tableColumns, loading: isLoading || isFetching, queryResults: data, defaultSortKey: (_f = defaultPaginationProps === null || defaultPaginationProps === void 0 ? void 0 : defaultPaginationProps.sortKey) !== null && _f !== void 0 ? _f : '', defaultSortDesc: !(defaultPaginationProps === null || defaultPaginationProps === void 0 ? void 0 : defaultPaginationProps.sortAsc), setPagination: setPaginatedProps, editPermissions: { requiredPermissions: ["edit:" + permissionName] }, onEdit: handleEdit, onRowClick: handleRowClick, customRowStyling: customRowStyling, noDataMessage: noDataMessage, isBorderVisible: false, showExtendedPaginationOptions: false, defaultPageSize: fixedPageSize, isRowsPerPageChangeable: fixedPageSize === undefined, isInactiveStyleApplied: showInactiveStyling, referenceNumberColumnKeySuffixes: referenceNumberColumnKeySuffixes }, void 0) }), void 0)] }), void 0) }, void 0));
};

var placeholderMutationHook$1 = function () { return [
    function (args) { },
    {
        isError: false,
        reset: function () { },
        data: undefined,
        isLoading: false,
    },
]; };
var StandardListViewV2 = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    var activateMutation = _a.activateMutation, additionalActionItems = _a.additionalActionItems, additionalMenuItems = _a.additionalMenuItems, _m = _a.additionalQueryParameters, additionalQueryParameters = _m === void 0 ? {} : _m, alternateInactivateIcons = _a.alternateInactivateIcons, _o = _a.breadCrumbs, breadCrumbs = _o === void 0 ? [] : _o, currentPageLabel = _a.currentPageLabel, customRowStyling = _a.customRowStyling, defaultPaginationProps = _a.defaultPaginationProps, deleteConfirmationDialog = _a.deleteConfirmationDialog, deleteMutation = _a.deleteMutation, disableEditForInactive = _a.disableEditForInactive, disableGutters = _a.disableGutters, disableRowPerPageSelection = _a.disableRowPerPageSelection, disableSelection = _a.disableSelection, disableActivateForRecord = _a.disableActivateForRecord, disableDeleteForRecord = _a.disableDeleteForRecord, disableInactiveForRecord = _a.disableInactiveForRecord, editIcon = _a.editIcon, editToolTip = _a.editToolTip, endTitleSlot = _a.endTitleSlot, entityNameSingular = _a.entityNameSingular, _p = _a.entityNamePlural, entityNamePlural = _p === void 0 ? entityNameSingular + "s" : _p, _q = _a.filterChips, filterChips = _q === void 0 ? [] : _q, getDataQuery = _a.getDataQuery, handleAdd = _a.handleAdd, handleEdit = _a.handleEdit, handleFilterChipDelete = _a.handleFilterChipDelete, handleFilterClicked = _a.handleFilterClicked, handleImportClicked = _a.handleImportClicked, handleRowClick = _a.handleRowClick, _r = _a.headerColor, headerColor = _r === void 0 ? 'default' : _r, _s = _a.headerIcon, headerIcon = _s === void 0 ? jsx(Fragment, {}, void 0) : _s, _t = _a.addButton, addButton = _t === void 0 ? (jsx(Tooltip, __assign({ title: 'Add New' }, { children: jsx(Button, __assign({ color: 'primary', startIcon: jsx(AddCircle, {}, void 0), variant: 'contained', size: 'small', disableElevation: true, onClick: handleAdd }, { children: "Add New" }), void 0) }), void 0)) : _t, headerTitle = _a.headerTitle, _u = _a.hideAddButtonDivider, hideAddButtonDivider = _u === void 0 ? false : _u, hideBorder = _a.hideBorder, hideDefaultMenuItems = _a.hideDefaultMenuItems, hideMenu = _a.hideMenu, _v = _a.hideMenuDivider, hideMenuDivider = _v === void 0 ? false : _v, hideSearch = _a.hideSearch, _w = _a.hideFilterButton, hideFilterButton = _w === void 0 ? false : _w, inactivateConfirmationDialog = _a.inactivateConfirmationDialog, inactivateMutation = _a.inactivateMutation, _x = _a.isPaginationVisible, isPaginationVisible = _x === void 0 ? true : _x, _y = _a.isShowActiveToggleVisible, isShowActiveToggleVisible = _y === void 0 ? false : _y, noDataMessage = _a.noDataMessage, onNoDataLoaded = _a.onNoDataLoaded, onQueryResultsChange = _a.onQueryResultsChange, onSelectedChange = _a.onSelectedChange, _z = _a.overrideEnableChipGutters, overrideEnableChipGutters = _z === void 0 ? false : _z, permissionName = _a.permissionName, preActionItemSlot = _a.preActionItemSlot, additionalHeaderToggle = _a.additionalHeaderToggle, showInactiveOverrideText = _a.showInactiveOverrideText, spacing = _a.spacing, tableColumns = _a.tableColumns, titleFontSize = _a.titleFontSize, _0 = _a.stickyTableHeader, stickyTableHeader = _0 === void 0 ? false : _0, maxTableHeight = _a.maxTableHeight, initialSearchText = _a.initialSearchText, initialPaginatedProps = _a.initialPaginatedProps, initialShowInactive = _a.initialShowInactive, onPaginationChange = _a.onPaginationChange, onSearchChange = _a.onSearchChange, onShowInactiveChange = _a.onShowInactiveChange, _1 = _a.enableMultiSort, enableMultiSort = _1 === void 0 ? false : _1, _2 = _a.paginationOnTop, paginationOnTop = _2 === void 0 ? false : _2, referenceNumberColumnKeySuffixes = _a.referenceNumberColumnKeySuffixes;
    var permissions = useContext(UserPermissionContext).permissions;
    var _3 = useState(null), menuAnchorEl = _3[0], setMenuAnchorEl = _3[1];
    var menuOpen = Boolean(menuAnchorEl);
    var _4 = useState(initialSearchText !== null && initialSearchText !== void 0 ? initialSearchText : ''), searchText = _4[0], setSearchText = _4[1];
    var _5 = useState(initialShowInactive !== null && initialShowInactive !== void 0 ? initialShowInactive : false), showInactive = _5[0], setShowInactive = _5[1];
    var _6 = useState(initialPaginatedProps !== null && initialPaginatedProps !== void 0 ? initialPaginatedProps : defaultPaginationProps), paginatedProps = _6[0], setPaginatedProps = _6[1];
    var queryParams = useMemo(function () {
        var _a, _b, _c, _d, _e;
        var sorting = (_a = paginatedProps === null || paginatedProps === void 0 ? void 0 : paginatedProps.sorting) !== null && _a !== void 0 ? _a : [];
        // Convert to API format: ['key1+', 'key2-', ...]
        var sortingArray = sorting.map(function (item) { return "" + item.key + (item.direction === 'asc' ? '+' : '-'); });
        var baseParams = __assign({ searchText: searchText, page: (_b = paginatedProps === null || paginatedProps === void 0 ? void 0 : paginatedProps.page) !== null && _b !== void 0 ? _b : 0, pageSize: (_c = paginatedProps === null || paginatedProps === void 0 ? void 0 : paginatedProps.pageSize) !== null && _c !== void 0 ? _c : 25, includeInactive: showInactive }, additionalQueryParameters);
        if (enableMultiSort) {
            // Multi-sort mode: only send sorting array
            return __assign(__assign({}, baseParams), { sorting: sortingArray });
        }
        else {
            // Single-sort mode: send both formats for backward compatibility
            return __assign(__assign({}, baseParams), { sortKey: (_d = paginatedProps === null || paginatedProps === void 0 ? void 0 : paginatedProps.sortKey) !== null && _d !== void 0 ? _d : '', sortAsc: (_e = paginatedProps === null || paginatedProps === void 0 ? void 0 : paginatedProps.sortAsc) !== null && _e !== void 0 ? _e : true, sorting: sortingArray });
        }
    }, [searchText, paginatedProps, showInactive, additionalQueryParameters, enableMultiSort]);
    var _7 = getDataQuery(queryParams), data = _7.data, isSuccess = _7.isSuccess, isLoading = _7.isLoading, error = _7.error, refetch = _7.refetch, isFetching = _7.isFetching;
    var _8 = useState([]), selectedRows = _8[0], setSelectedRows = _8[1];
    var _9 = useState(false), isDeleteConfirmationDialogOpen = _9[0], setIsDeleteConfirmationDialogOpen = _9[1];
    var _10 = useState(false), isInactivateConfirmationDialogOpen = _10[0], setIsInactivateConfirmationDialogOpen = _10[1];
    useEffect(function () {
        if (onQueryResultsChange) {
            onQueryResultsChange(data);
        }
    }, [data, onQueryResultsChange]);
    useEffect(function () {
        if (!!onSelectedChange) {
            onSelectedChange(selectedRows);
        }
    }, [selectedRows, onSelectedChange]);
    useEffect(function () {
        if (!!onPaginationChange) {
            onPaginationChange(paginatedProps);
        }
    }, [paginatedProps, onPaginationChange]);
    useEffect(function () {
        if (!!onSearchChange) {
            onSearchChange(searchText);
        }
    }, [searchText, onSearchChange]);
    useEffect(function () {
        if (!!onShowInactiveChange) {
            onShowInactiveChange(showInactive);
        }
    }, [showInactive, onShowInactiveChange]);
    var defaultIfNotProvided = placeholderMutationHook$1;
    var _11 = (inactivateMutation !== null && inactivateMutation !== void 0 ? inactivateMutation : defaultIfNotProvided)(), inactivateRecords = _11[0], _12 = _11[1], isInactivateError = _12.isError, resetInactivate = _12.reset, inactivateResult = _12.data, isInactivating = _12.isLoading;
    var _13 = (activateMutation !== null && activateMutation !== void 0 ? activateMutation : defaultIfNotProvided)(), activateRecords = _13[0], _14 = _13[1], isActivateError = _14.isError, resetActivate = _14.reset, activateResult = _14.data, isActivating = _14.isLoading;
    var _15 = (deleteMutation !== null && deleteMutation !== void 0 ? deleteMutation : defaultIfNotProvided)(), deleteRecords = _15[0], _16 = _15[1], isDeleteError = _16.isError, resetDelete = _16.reset, deleteResult = _16.data, isDeleting = _16.isLoading;
    useActivateInactivateSnackbar('Inactivate', entityNameSingular, entityNamePlural, inactivateResult, resetInactivate);
    useFailedActionSnackbar('inactivate', entityNamePlural, isInactivateError, resetInactivate);
    useActivateInactivateSnackbar('Activate', entityNameSingular, entityNamePlural, activateResult, resetActivate);
    useFailedActionSnackbar('activate', entityNamePlural, isActivateError, resetActivate);
    useActivateInactivateSnackbar('Delete', entityNameSingular, entityNamePlural, deleteResult, resetDelete);
    useFailedActionSnackbar('delete', entityNamePlural, isDeleteError, resetDelete);
    useEffect(function () {
        if (onNoDataLoaded) {
            if (!isLoading && !isFetching && isSuccess && data && data.totalQueryResults === 0) {
                onNoDataLoaded();
            }
        }
    }, [data, isFetching, isLoading, isSuccess, onNoDataLoaded]);
    var handleSearchChange = useCallback(function (newText) {
        setSearchText(newText);
    }, []);
    var handleActiveToggleChange = useCallback(function (event) {
        setShowInactive(event.target.checked);
    }, []);
    var handleMenuOpen = useCallback(function (event) {
        setMenuAnchorEl(event.currentTarget);
    }, []);
    var handleMenuClose = useCallback(function () {
        setMenuAnchorEl(null);
    }, []);
    var handleMenuEdit = useCallback(function (event) {
        var selectedRecord = selectedRows[0];
        if (selectedRecord && handleEdit) {
            handleEdit(selectedRecord.id, selectedRecord, event);
        }
    }, [handleEdit, selectedRows]);
    var canEdit = useMemo(function () {
        return selectedRows.length === 1 && (selectedRows[0].isActive || !disableEditForInactive);
    }, [selectedRows, disableEditForInactive]);
    var canSetInactive = useMemo(function () {
        return selectedRows.some(function (row) { return row.isActive && (!disableInactiveForRecord || !disableInactiveForRecord(row)); });
    }, [disableInactiveForRecord, selectedRows]);
    var canSetActive = useMemo(function () {
        return selectedRows.some(function (row) { return !row.isActive && (!disableActivateForRecord || !disableActivateForRecord(row)); });
    }, [disableActivateForRecord, selectedRows]);
    var canDelete = useMemo(function () {
        return selectedRows.some(function (row) { return !disableDeleteForRecord || !disableDeleteForRecord(row); });
    }, [disableDeleteForRecord, selectedRows]);
    var handleSetInactive = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var recordIds;
        return __generator(this, function (_a) {
            recordIds = selectedRows
                .filter(function (record) { return record.isActive && (!disableInactiveForRecord || !disableInactiveForRecord(record)); })
                .map(function (record) { return record.id; });
            inactivateRecords(recordIds);
            setSelectedRows([]);
            return [2 /*return*/];
        });
    }); }, [disableInactiveForRecord, inactivateRecords, selectedRows]);
    var handleSetActive = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var recordIds;
        return __generator(this, function (_a) {
            recordIds = selectedRows
                .filter(function (record) { return !record.isActive && (!disableActivateForRecord || !disableActivateForRecord(record)); })
                .map(function (record) { return record.id; });
            activateRecords(recordIds);
            setSelectedRows([]);
            return [2 /*return*/];
        });
    }); }, [activateRecords, disableActivateForRecord, selectedRows]);
    var handleDelete = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var recordIds;
        return __generator(this, function (_a) {
            recordIds = selectedRows
                .filter(function (record) { return !disableDeleteForRecord || !disableDeleteForRecord(record); })
                .map(function (record) { return record.id; });
            deleteRecords(recordIds);
            setSelectedRows([]);
            return [2 /*return*/];
        });
    }); }, [selectedRows, deleteRecords, disableDeleteForRecord]);
    var permittedExtraItems = useCallback(function (extraItems) {
        if (!extraItems) {
            return [];
        }
        return extraItems.filter(function (menuItem) { var _a; return userHasPermissions((_a = menuItem.requiredPermissions) !== null && _a !== void 0 ? _a : [], permissions, menuItem.permissionLogic); });
    }, [permissions]);
    var handleClearSelectedItems = useCallback(function () {
        if (selectedRows.length > 0) {
            setSelectedRows([]);
        }
    }, [selectedRows.length]);
    var renderAdditionalMenuItems = useCallback(function () {
        if (permittedExtraItems(additionalMenuItems).length === 0) {
            return null;
        }
        var menuItems = permittedExtraItems(additionalMenuItems).map(function (menuItem, idx) {
            var isEnabled = !menuItem.enabledCheck || menuItem.enabledCheck(selectedRows);
            return (jsx(MenuItem, __assign({ onClick: function (e) {
                    handleMenuClose();
                    menuItem.onClick(selectedRows);
                    if (menuItem.clearSelectedItems) {
                        handleClearSelectedItems();
                    }
                }, disabled: !isEnabled }, { children: menuItem.text }), menuItem.text + "-" + idx));
        });
        return !hideMenuDivider ? __spreadArrays([jsx(Divider, {}, "additional-menu-divider")], menuItems) : __spreadArrays(menuItems);
    }, [additionalMenuItems, handleClearSelectedItems, handleMenuClose, hideMenuDivider, permittedExtraItems, selectedRows]);
    var renderAdditionalActionItems = useCallback(function () {
        if (permittedExtraItems(additionalActionItems).length === 0) {
            return null;
        }
        var actionItems = permittedExtraItems(additionalActionItems).map(function (actionItem, idx) {
            var isEnabled = !actionItem.enabledCheck || actionItem.enabledCheck(selectedRows);
            if (actionItem.buttonIsIconButton) {
                return (jsx(Tooltip, __assign({ title: actionItem.text }, { children: jsx(IconButton, __assign({ size: 'large', onClick: function () {
                            handleMenuClose();
                            actionItem.onClick(selectedRows);
                            if (actionItem.clearSelectedItems) {
                                handleClearSelectedItems();
                            }
                        }, disabled: !isEnabled }, { children: actionItem.icon }), void 0) }), actionItem.text + "-" + idx));
            }
            return (jsx(Button, __assign({ color: 'primary', startIcon: actionItem.icon, variant: 'contained', size: 'small', disableElevation: true, onClick: function () {
                    handleMenuClose();
                    actionItem.onClick(selectedRows);
                    if (actionItem.clearSelectedItems) {
                        handleClearSelectedItems();
                    }
                }, disabled: !isEnabled, sx: { textTransform: actionItem.preventTextTransform ? 'none' : 'inherit' } }, { children: actionItem.text }), actionItem.text + "-" + idx));
        });
        return actionItems;
    }, [additionalActionItems, handleClearSelectedItems, handleMenuClose, permittedExtraItems, selectedRows]);
    var renderFilterChips = useCallback(function () {
        if (filterChips.length > 0) {
            return (jsx(Grid, __assign({ item: true, display: 'flex', gap: 1, py: 1, px: disableGutters && !overrideEnableChipGutters ? 0 : 2 }, { children: filterChips.map(function (filterChip) {
                    var _a;
                    return (jsx(Chip, { label: "" + filterChip.key + ((_a = filterChip.separator) !== null && _a !== void 0 ? _a : ':') + " " + filterChip.text, color: 'primary', onDelete: handleFilterChipDelete ? function () { return handleFilterChipDelete(filterChip.key); } : undefined }, filterChip.key));
                }) }), void 0));
        }
        return null;
    }, [disableGutters, filterChips, handleFilterChipDelete, overrideEnableChipGutters]);
    var ActivateInactivateButton = useMemo(function () {
        var areMixedRecordsSelected = canSetActive && canSetInactive;
        if (activateMutation && canSetActive && !canSetInactive) {
            return (jsx(Tooltip, __assign({ title: 'Make Active' }, { children: jsx("span", { children: jsx(IconButton, __assign({ size: 'large', onClick: handleSetActive, disabled: isActivating }, { children: alternateInactivateIcons ? jsx(RestoreFromTrash, { fontSize: 'inherit' }, void 0) : jsx(Unarchive, { fontSize: 'inherit' }, void 0) }), void 0) }, void 0) }), void 0));
        }
        else if (inactivateMutation) {
            return (jsx(Tooltip, __assign({ title: areMixedRecordsSelected ? 'Cannot Activate or Inactivate records when both active and inactive records are selected' : 'Make Inactive' }, { children: jsx("span", { children: jsx(IconButton, __assign({ size: 'large', onClick: function () {
                            if (inactivateConfirmationDialog) {
                                setIsInactivateConfirmationDialogOpen(true);
                            }
                            else {
                                handleSetInactive();
                            }
                        }, disabled: !canSetInactive || areMixedRecordsSelected || isInactivating }, { children: alternateInactivateIcons ? jsx(Delete, { fontSize: 'inherit' }, void 0) : jsx(Archive, { fontSize: 'inherit' }, void 0) }), void 0) }, void 0) }), void 0));
        }
        else {
            return null;
        }
    }, [
        canSetActive,
        canSetInactive,
        activateMutation,
        inactivateMutation,
        handleSetActive,
        isActivating,
        alternateInactivateIcons,
        isInactivating,
        inactivateConfirmationDialog,
        handleSetInactive,
    ]);
    var renderConfirmationDialog = useCallback(function (isOpen, title, content, onCancel, onConfirm) {
        return (jsx(ConfirmationModalWrapper, __assign({ isOpen: !!isOpen, title: title, cancel: onCancel, confirm: onConfirm }, { children: content }), void 0));
    }, []);
    var headerFilterAndSearch = useCallback(function () { return (jsxs(Fragment, { children: [(handleFilterClicked || !hideSearch || !hideFilterButton) && !paginationOnTop && jsx(Divider, { flexItem: true, orientation: 'vertical' }, void 0),
            !hideFilterButton && handleFilterClicked && (jsx(Tooltip, __assign({ title: 'Filter' }, { children: jsx("span", { children: jsx(IconButton, __assign({ size: 'large', onClick: handleFilterClicked, color: 'primary' }, { children: jsx(FilterList, { fontSize: 'inherit' }, void 0) }), void 0) }, void 0) }), void 0)),
            !hideSearch && (jsx("div", { children: jsx(StandardSearchInput, { searchText: searchText, handleSearchChange: handleSearchChange, isLoading: isFetching, textFieldProps: {
                        size: 'small',
                        variant: 'standard',
                        label: undefined,
                    } }, void 0) }, void 0)),
            (isShowActiveToggleVisible || activateMutation || inactivateMutation || deleteMutation || handleImportClicked) && !paginationOnTop && (jsx(Divider, { flexItem: true, orientation: 'vertical', sx: { ml: 1, mr: isShowActiveToggleVisible ? 0 : 1 } }, void 0)),
            isShowActiveToggleVisible && (jsx(FormControlLabel, { control: jsx(Switch, { checked: showInactive, onChange: handleActiveToggleChange, size: 'small' }, void 0), label: showInactiveOverrideText !== null && showInactiveOverrideText !== void 0 ? showInactiveOverrideText : 'Show Inactive', labelPlacement: 'start', sx: { marginRight: '5px' } }, void 0)), additionalHeaderToggle] }, void 0)); }, [handleFilterClicked, hideSearch, hideFilterButton, paginationOnTop, searchText, handleSearchChange, isFetching, isShowActiveToggleVisible, activateMutation, inactivateMutation, deleteMutation, handleImportClicked, showInactive, handleActiveToggleChange, showInactiveOverrideText, additionalHeaderToggle]);
    var renderHeaderFilterAndSearch = useCallback(function () { return (jsx(Box, __assign({ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'nowrap' }, { children: headerFilterAndSearch() }), void 0)); }, [headerFilterAndSearch]);
    var renderHeaderActions = useCallback(function () { return (jsxs(Grid, __assign({ item: true, display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'end', xs: 12, sx: { gap: 1 }, pr: 2, py: 1 }, { children: [preActionItemSlot, !paginationOnTop && headerFilterAndSearch(), jsx(AuthenticatedComponent, { requiredPermissions: ["inactivate:" + permissionName], children: ActivateInactivateButton }, void 0),
            deleteMutation && (jsx(AuthenticatedComponent, __assign({ requiredPermissions: ["delete:" + permissionName] }, { children: jsx(Tooltip, __assign({ title: 'Delete' }, { children: jsx("span", { children: jsx(IconButton, __assign({ size: 'large', onClick: function () {
                                if (deleteConfirmationDialog) {
                                    setIsDeleteConfirmationDialogOpen(true);
                                }
                                else {
                                    handleDelete();
                                }
                            }, disabled: !canDelete || isDeleting }, { children: jsx(Delete, { fontSize: 'inherit' }, void 0) }), void 0) }, void 0) }), void 0) }), void 0)),
            handleImportClicked && (jsx(AuthenticatedComponent, __assign({ requiredPermissions: ["create:" + permissionName] }, { children: jsx(Tooltip, __assign({ title: 'Import' }, { children: jsx("span", { children: jsx(IconButton, __assign({ size: 'large', onClick: handleImportClicked }, { children: jsx(UploadFile, { fontSize: 'inherit' }, void 0) }), void 0) }, void 0) }), void 0) }), void 0)),
            (handleAdd || !hideMenu) && !hideAddButtonDivider && jsx(Divider, { flexItem: true, orientation: 'vertical', sx: { mx: 1 } }, void 0), renderAdditionalActionItems(), handleAdd && jsx(AuthenticatedComponent, { requiredPermissions: ["create:" + permissionName], children: addButton }, void 0),
            !hideMenu && (jsx(AuthenticatedComponent, __assign({ requiredPermissions: permittedExtraItems(additionalMenuItems).length > 0
                    ? []
                    : ["create:" + permissionName, "edit:" + permissionName, "delete:" + permissionName, "inactivate:" + permissionName], logic: 'or' }, { children: jsxs(Fragment, { children: [jsx(IconButton, __assign({ onClick: handleMenuOpen }, { children: jsx(MoreVert, { fontSize: 'inherit' }, void 0) }), void 0),
                        jsxs(Menu, __assign({ anchorEl: menuAnchorEl, open: menuOpen, onClose: handleMenuClose, anchorOrigin: {
                                vertical: 'bottom',
                                horizontal: 'center',
                            }, transformOrigin: {
                                vertical: 'top',
                                horizontal: 'right',
                            } }, { children: [!hideDefaultMenuItems && handleAdd && (jsx(AuthenticatedComponent, __assign({ requiredPermissions: ["create:" + permissionName] }, { children: jsx(MenuItem, __assign({ onClick: function (e) {
                                            handleMenuClose();
                                            handleAdd(e);
                                        } }, { children: "Add New" }), void 0) }), void 0)),
                                !hideDefaultMenuItems && handleEdit && (jsx(AuthenticatedComponent, __assign({ requiredPermissions: ["edit:" + permissionName] }, { children: jsx(MenuItem, __assign({ onClick: function (e) {
                                            handleMenuClose();
                                            handleMenuEdit(e);
                                        }, disabled: !canEdit }, { children: "Edit" }), void 0) }), void 0)),
                                !hideDefaultMenuItems && handleImportClicked && (jsx(AuthenticatedComponent, __assign({ requiredPermissions: ["create:" + permissionName] }, { children: jsx(MenuItem, __assign({ onClick: function (e) {
                                            handleMenuClose();
                                            handleImportClicked(e);
                                        } }, { children: "Import" }), void 0) }), void 0)),
                                !hideDefaultMenuItems && (activateMutation || inactivateMutation || deleteMutation) && (jsx(AuthenticatedComponent, __assign({ requiredPermissions: ["inactivate:" + permissionName, "delete:" + permissionName], logic: 'or' }, { children: jsx(Divider, {}, void 0) }), void 0)),
                                !hideDefaultMenuItems && activateMutation && (jsx(AuthenticatedComponent, __assign({ requiredPermissions: ["inactivate:" + permissionName] }, { children: jsx(MenuItem, __assign({ onClick: function (e) {
                                            handleMenuClose();
                                            handleSetActive();
                                        }, disabled: !canSetActive || isActivating }, { children: "Make Active" }), void 0) }), void 0)),
                                !hideDefaultMenuItems && inactivateMutation && (jsx(AuthenticatedComponent, __assign({ requiredPermissions: ["inactivate:" + permissionName] }, { children: jsx(MenuItem, __assign({ onClick: function () {
                                            handleMenuClose();
                                            if (inactivateConfirmationDialog) {
                                                setIsInactivateConfirmationDialogOpen(true);
                                            }
                                            else {
                                                handleSetInactive();
                                            }
                                        }, disabled: !canSetInactive || isInactivating }, { children: "Make Inactive" }), void 0) }), void 0)),
                                !hideDefaultMenuItems && deleteMutation && (jsx(AuthenticatedComponent, __assign({ requiredPermissions: ["delete:" + permissionName] }, { children: jsx(MenuItem, __assign({ onClick: function () {
                                            handleMenuClose();
                                            if (deleteConfirmationDialog) {
                                                setIsDeleteConfirmationDialogOpen(true);
                                            }
                                            else {
                                                handleDelete();
                                            }
                                        }, disabled: !canDelete || isDeleting }, { children: "Delete" }), void 0) }), void 0)), renderAdditionalMenuItems()] }), void 0)] }, void 0) }), void 0))] }), void 0)); }, [preActionItemSlot, paginationOnTop, headerFilterAndSearch, permissionName, ActivateInactivateButton, deleteMutation, canDelete, isDeleting, handleImportClicked, handleAdd, hideMenu, hideAddButtonDivider, renderAdditionalActionItems, addButton, permittedExtraItems, additionalMenuItems, handleMenuOpen, menuAnchorEl, menuOpen, handleMenuClose, hideDefaultMenuItems, handleEdit, canEdit, activateMutation, inactivateMutation, canSetActive, isActivating, canSetInactive, isInactivating, renderAdditionalMenuItems, deleteConfirmationDialog, handleDelete, handleMenuEdit, handleSetActive, inactivateConfirmationDialog, handleSetInactive]);
    if (isLoading) {
        return jsx(LoadingIndicator, {}, void 0);
    }
    if (error) {
        return jsx(ApiError, { onReloadClick: refetch }, void 0);
    }
    return (jsxs(Grid, __assign({ container: true, direction: 'column', rowSpacing: spacing, sx: (paginationOnTop && stickyTableHeader) ? { height: '100%', display: 'flex', flexDirection: 'column', width: '100%', minWidth: 0 } : { width: '100%', minWidth: 0 } }, { children: [jsx(Box, __assign({ sx: stickyTableHeader ? { position: 'sticky', top: '67px', zIndex: 1100, backgroundColor: 'background.paper' } : {} }, { children: jsx(SlimPageHeader, { icon: headerIcon, title: headerTitle, titleFontSize: titleFontSize, color: headerColor, breadCrumbProps: breadCrumbs.length > 0
                        ? {
                            links: breadCrumbs !== null && breadCrumbs !== void 0 ? breadCrumbs : [],
                            currentPageLabel: currentPageLabel !== null && currentPageLabel !== void 0 ? currentPageLabel : entityNamePlural,
                        }
                        : undefined, endTitleSlot: endTitleSlot, endSlot: renderHeaderActions(), disableBorderRadius: true, disableGutters: disableGutters }, void 0) }), void 0), renderFilterChips(), deleteConfirmationDialog &&
                renderConfirmationDialog(isDeleteConfirmationDialogOpen, deleteConfirmationDialog.title, deleteConfirmationDialog.content, function () {
                    setIsDeleteConfirmationDialogOpen(false);
                }, function () {
                    setIsDeleteConfirmationDialogOpen(false);
                    handleDelete();
                }),
            inactivateConfirmationDialog &&
                renderConfirmationDialog(isInactivateConfirmationDialogOpen, inactivateConfirmationDialog.title, inactivateConfirmationDialog.content, function () {
                    setIsInactivateConfirmationDialogOpen(false);
                }, function () {
                    setIsInactivateConfirmationDialogOpen(false);
                    handleSetInactive();
                }),
            jsx(Grid, __assign({ item: true, px: disableGutters ? 0 : 2, sx: paginationOnTop ? { flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0, width: '100%', minWidth: 0 } : { width: '100%', minWidth: 0 } }, { children: jsx(PaginatedDataTable, { columns: tableColumns, loading: isLoading || isFetching, queryResults: data, defaultSortKey: (_c = (_b = initialPaginatedProps === null || initialPaginatedProps === void 0 ? void 0 : initialPaginatedProps.sortKey) !== null && _b !== void 0 ? _b : defaultPaginationProps === null || defaultPaginationProps === void 0 ? void 0 : defaultPaginationProps.sortKey) !== null && _c !== void 0 ? _c : '', defaultSortDesc: !((_e = (_d = initialPaginatedProps === null || initialPaginatedProps === void 0 ? void 0 : initialPaginatedProps.sortAsc) !== null && _d !== void 0 ? _d : defaultPaginationProps === null || defaultPaginationProps === void 0 ? void 0 : defaultPaginationProps.sortAsc) !== null && _e !== void 0 ? _e : true), defaultSorting: (_g = (_f = initialPaginatedProps === null || initialPaginatedProps === void 0 ? void 0 : initialPaginatedProps.sorting) !== null && _f !== void 0 ? _f : defaultPaginationProps === null || defaultPaginationProps === void 0 ? void 0 : defaultPaginationProps.sorting) !== null && _g !== void 0 ? _g : [], defaultPage: (_j = (_h = initialPaginatedProps === null || initialPaginatedProps === void 0 ? void 0 : initialPaginatedProps.page) !== null && _h !== void 0 ? _h : defaultPaginationProps === null || defaultPaginationProps === void 0 ? void 0 : defaultPaginationProps.page) !== null && _j !== void 0 ? _j : 0, defaultPageSize: (_l = (_k = initialPaginatedProps === null || initialPaginatedProps === void 0 ? void 0 : initialPaginatedProps.pageSize) !== null && _k !== void 0 ? _k : defaultPaginationProps === null || defaultPaginationProps === void 0 ? void 0 : defaultPaginationProps.pageSize) !== null && _l !== void 0 ? _l : 25, setPagination: setPaginatedProps, selectedRecords: disableSelection ? undefined : selectedRows, setSelectedRecords: disableSelection ? undefined : setSelectedRows, editIcon: editIcon, editToolTip: editToolTip, editPermissions: { requiredPermissions: ["edit:" + permissionName] }, onEdit: handleEdit, onRowClick: handleRowClick, isPaginationVisible: isPaginationVisible, isRowsPerPageChangeable: !disableRowPerPageSelection, customRowStyling: customRowStyling, noDataMessage: noDataMessage, disableEditForInactive: disableEditForInactive !== null && disableEditForInactive !== void 0 ? disableEditForInactive : undefined, isBorderVisible: !hideBorder, stickyHeader: stickyTableHeader, maxTableHeight: maxTableHeight, enableMultiSort: enableMultiSort, paginationOnTop: paginationOnTop, tableControlsSlot: paginationOnTop ? renderHeaderFilterAndSearch() : undefined, referenceNumberColumnKeySuffixes: referenceNumberColumnKeySuffixes }, void 0) }), void 0)] }), void 0));
};

var placeholderMutationHook = function () { return [
    function (args) { },
    {
        isError: false,
        reset: function () { },
        data: undefined,
        isLoading: false,
    },
]; };
var StandardListView = function (props) {
    var _a;
    var permissions = useContext(UserPermissionContext).permissions;
    var defaultPaginationProps = props.defaultPaginationProps, tableColumns = props.tableColumns, getDataQuery = props.getDataQuery, archiveMutation = props.archiveMutation, recoverMutation = props.recoverMutation, entityNameSingular = props.entityNameSingular, _b = props.entityNamePlural, entityNamePlural = _b === void 0 ? entityNameSingular + "s" : _b, permissionName = props.permissionName, handleAdd = props.handleAdd, handleEdit = props.handleEdit, handleRowClick = props.handleRowClick, headerTitle = props.headerTitle, headerIcon = props.headerIcon, breadCrumbs = props.breadCrumbs, _c = props.additionalQueryParameters, additionalQueryParameters = _c === void 0 ? {} : _c, _d = props.isHeaderVisible, isHeaderVisible = _d === void 0 ? true : _d, _e = props.isRowSelectionEnabled, isRowSelectionEnabled = _e === void 0 ? true : _e, _f = props.isPaginationVisible, isPaginationVisible = _f === void 0 ? true : _f, _g = props.isBorderVisible, isBorderVisible = _g === void 0 ? true : _g, editIcon = props.editIcon, editToolTip = props.editToolTip, handleImportClicked = props.handleImportClicked, handleFilterClicked = props.handleFilterClicked, _h = props.filterChips, filterChips = _h === void 0 ? [] : _h, handleFilterChipDelete = props.handleFilterChipDelete, additionalMenuItems = props.additionalMenuItems, subtitleComponentOverride = props.subtitleComponentOverride, _j = props.showMenu, showMenu = _j === void 0 ? true : _j, _k = props.showSearch, showSearch = _k === void 0 ? true : _k, _l = props.showInactiveToggle, showInactiveToggle = _l === void 0 ? true : _l, _m = props.showFilterButton, showFilterButton = _m === void 0 ? true : _m, archiveIntercept = props.archiveIntercept, recoverIntercept = props.recoverIntercept, afterActionItemsSlot = props.afterActionItemsSlot, hideDefaultMenuItems = props.hideDefaultMenuItems, referenceNumberColumnKeySuffixes = props.referenceNumberColumnKeySuffixes;
    var _o = useState(null), menuAnchorEl = _o[0], setMenuAnchorEl = _o[1];
    var menuOpen = Boolean(menuAnchorEl);
    var _p = useState(''), searchText = _p[0], setSearchText = _p[1];
    var _q = useState(false), showInactive = _q[0], setShowInactive = _q[1];
    var _r = useState(defaultPaginationProps), paginatedProps = _r[0], setPaginatedProps = _r[1];
    var _s = getDataQuery(__assign({ searchText: searchText, sortKey: paginatedProps === null || paginatedProps === void 0 ? void 0 : paginatedProps.sortKey, sortAsc: paginatedProps === null || paginatedProps === void 0 ? void 0 : paginatedProps.sortAsc, page: paginatedProps === null || paginatedProps === void 0 ? void 0 : paginatedProps.page, pageSize: paginatedProps === null || paginatedProps === void 0 ? void 0 : paginatedProps.pageSize, includeInactive: showInactive }, additionalQueryParameters)), data = _s.data, isLoading = _s.isLoading, error = _s.error, refetch = _s.refetch, isFetching = _s.isFetching;
    var _t = useState([]), selectedRows = _t[0], setSelectedRows = _t[1];
    var defaultIfNotProvided = placeholderMutationHook;
    var _u = (archiveMutation !== null && archiveMutation !== void 0 ? archiveMutation : defaultIfNotProvided)(), archiveRecords = _u[0], _v = _u[1], isArchiveError = _v.isError, resetArchive = _v.reset, archiveResult = _v.data;
    var _w = (recoverMutation !== null && recoverMutation !== void 0 ? recoverMutation : defaultIfNotProvided)(), unarchiveRecords = _w[0], _x = _w[1], isUnarchiveError = _x.isError, resetUnarchive = _x.reset, unarchiveResult = _x.data;
    useActivateInactivateSnackbar('Inactivate', entityNameSingular, entityNamePlural, archiveResult, resetArchive);
    useFailedActionSnackbar('inactivate', entityNamePlural, isArchiveError, resetArchive);
    useActivateInactivateSnackbar('Activate', entityNameSingular, entityNamePlural, unarchiveResult, resetUnarchive);
    useFailedActionSnackbar('activate', entityNamePlural, isUnarchiveError, resetUnarchive);
    var handleClearSelectedItems = useCallback(function () {
        if (selectedRows.length > 0) {
            setSelectedRows([]);
        }
    }, [selectedRows.length]);
    var handleSearchChange = function (newText) {
        setSearchText(newText);
    };
    var handleActiveToggleChange = function (event) {
        setShowInactive(event.target.checked);
    };
    var handleMenuOpen = function (event) {
        setMenuAnchorEl(event.currentTarget);
    };
    var handleMenuClose = function (afterClose) { return function () {
        setMenuAnchorEl(null);
        if (afterClose) {
            afterClose();
        }
    }; };
    var handleMenuEdit = function () {
        var selectedRecord = data === null || data === void 0 ? void 0 : data.pageResults.find(function (result) { return result.id === selectedRows[0]; });
        if (selectedRecord && handleEdit) {
            handleEdit(selectedRecord.id, selectedRecord);
        }
    };
    var handleSetActive = function () {
        if (recoverIntercept) {
            recoverIntercept(selectedRows, unarchiveRecords);
        }
        else {
            unarchiveRecords(selectedRows);
        }
        setSelectedRows([]);
    };
    var handleSetInactive = function () {
        if (archiveIntercept) {
            archiveIntercept(selectedRows, archiveRecords);
        }
        else {
            archiveRecords(selectedRows);
        }
        setSelectedRows([]);
    };
    var canSetActive = function () {
        return selectedRows.some(function (record) { return !record.isActive; });
    };
    var canSetInactive = function () {
        return selectedRows.some(function (record) { return record.isActive; });
    };
    var permittedAdditionalMenuItems = useCallback(function () {
        if (!additionalMenuItems) {
            return [];
        }
        return additionalMenuItems.filter(function (menuItem) { var _a; return userHasPermissions((_a = menuItem.requiredPermissions) !== null && _a !== void 0 ? _a : [], permissions, menuItem.permissionLogic); });
    }, [additionalMenuItems, permissions]);
    var renderAdditionalMenuItems = function () {
        if (permittedAdditionalMenuItems().length === 0) {
            return null;
        }
        var menuItems = permittedAdditionalMenuItems().map(function (menuItem, idx) {
            var isEnabled = !menuItem.enabledCheck || menuItem.enabledCheck(selectedRows);
            return (jsx(MenuItem, __assign({ onClick: handleMenuClose(function () {
                    menuItem.onClick(selectedRows);
                    if (menuItem.clearSelectedItems) {
                        handleClearSelectedItems();
                    }
                }), disabled: !isEnabled }, { children: menuItem.text }), menuItem.text + "-" + idx));
        });
        if (hideDefaultMenuItems) {
            return menuItems;
        }
        else {
            return __spreadArrays([jsx(Divider, {}, void 0)], menuItems);
        }
    };
    var renderFilterChips = function () {
        if (filterChips.length > 0) {
            return (jsx(Grid, __assign({ item: true, display: 'flex', gap: 1, pb: 2 }, { children: filterChips.map(function (filterChip) {
                    var _a;
                    return (jsx(Chip, { label: "" + filterChip.key + ((_a = filterChip.separator) !== null && _a !== void 0 ? _a : ':') + " " + filterChip.text, color: 'primary', onDelete: handleFilterChipDelete ? function () { return handleFilterChipDelete(filterChip.key); } : undefined }, filterChip.key));
                }) }), void 0));
        }
        return null;
    };
    var renderSubtitleSection = function () {
        if (!subtitleComponentOverride) {
            return renderFilterChips();
        }
        else {
            return subtitleComponentOverride;
        }
    };
    if (isLoading) {
        return jsx(LoadingIndicator, {}, void 0);
    }
    if (error) {
        return jsx(ApiError, { onReloadClick: refetch }, void 0);
    }
    return (jsxs(Grid, __assign({ container: true, direction: 'column' }, { children: [isHeaderVisible && (jsxs(Grid, __assign({ item: true, container: true, direction: 'row', alignItems: 'start', pb: 2 }, { children: [jsxs(Grid, __assign({ item: true, container: true, direction: 'column', justifyContent: 'start', xs: 4 }, { children: [(headerIcon || headerTitle) && (jsxs(Typography, __assign({ variant: 'h1', sx: { marginBottom: '8px' } }, { children: [headerIcon, " ", headerTitle] }), void 0)),
                            breadCrumbs ? jsx(NavBreadcrumbs, { links: breadCrumbs, currentPageLabel: entityNamePlural }, void 0) : renderSubtitleSection()] }), void 0),
                    jsxs(Grid, __assign({ item: true, display: 'flex', justifyContent: 'end', xs: 8 }, { children: [showInactiveToggle && (jsx(FormControlLabel, { control: jsx(Switch, { checked: showInactive, onChange: handleActiveToggleChange }, void 0), label: 'Show Inactive', labelPlacement: 'start' }, void 0)),
                            archiveMutation && (jsx(AuthenticatedComponent, __assign({ requiredPermissions: ["delete:" + permissionName] }, { children: jsx(Tooltip, __assign({ title: 'Make Inactive' }, { children: jsx("span", { children: jsx(IconButton, __assign({ size: 'large', onClick: handleSetInactive, disabled: !canSetInactive() }, { children: jsx(Delete, { fontSize: 'inherit' }, void 0) }), void 0) }, void 0) }), void 0) }), void 0)),
                            !!showFilterButton && handleFilterClicked && (jsx(Tooltip, __assign({ title: 'Filter' }, { children: jsx("span", { children: jsx(IconButton, __assign({ size: 'large', onClick: handleFilterClicked, color: 'primary' }, { children: jsx(FilterList, { fontSize: 'inherit' }, void 0) }), void 0) }, void 0) }), void 0)),
                            handleImportClicked && (jsx(AuthenticatedComponent, __assign({ requiredPermissions: ["create:" + permissionName] }, { children: jsx(Tooltip, __assign({ title: 'Import' }, { children: jsx("span", { children: jsx(IconButton, __assign({ size: 'large', onClick: handleImportClicked }, { children: jsx(UploadFile, { fontSize: 'inherit' }, void 0) }), void 0) }, void 0) }), void 0) }), void 0)),
                            handleAdd && (jsx(AuthenticatedComponent, __assign({ requiredPermissions: ["create:" + permissionName] }, { children: jsx(Tooltip, __assign({ title: 'Add New' }, { children: jsx(IconButton, __assign({ color: 'primary', size: 'large', onClick: handleAdd }, { children: jsx(AddCircle, { fontSize: 'inherit' }, void 0) }), void 0) }), void 0) }), void 0)),
                            showMenu && (jsx(AuthenticatedComponent, __assign({ requiredPermissions: permittedAdditionalMenuItems().length > 0
                                    ? []
                                    : ["create:" + permissionName, "edit:" + permissionName, "delete:" + permissionName], logic: 'or' }, { children: jsxs(Fragment, { children: [jsx(IconButton, __assign({ size: 'large', onClick: handleMenuOpen }, { children: jsx(MoreVert, { fontSize: 'inherit' }, void 0) }), void 0),
                                        jsxs(Menu, __assign({ anchorEl: menuAnchorEl, open: menuOpen, onClose: handleMenuClose(), anchorOrigin: {
                                                vertical: 'bottom',
                                                horizontal: 'center',
                                            }, transformOrigin: {
                                                vertical: 'top',
                                                horizontal: 'right',
                                            } }, { children: [!hideDefaultMenuItems && (jsxs(Fragment, { children: [handleAdd && (jsxs(AuthenticatedComponent, __assign({ requiredPermissions: ["create:" + permissionName] }, { children: [' ', jsx(MenuItem, __assign({ onClick: handleMenuClose(handleAdd) }, { children: "Add New" }), void 0), ' '] }), void 0)),
                                                        handleEdit && (jsx(AuthenticatedComponent, __assign({ requiredPermissions: ["edit:" + permissionName] }, { children: jsx(MenuItem, __assign({ onClick: handleMenuClose(handleMenuEdit), disabled: selectedRows.length !== 1 || (data === null || data === void 0 ? void 0 : data.pageResults.some(function (result) { return result.id === selectedRows[0]; })) }, { children: "Edit" }), void 0) }), void 0)),
                                                        handleImportClicked && (jsx(AuthenticatedComponent, __assign({ requiredPermissions: ["create:" + permissionName] }, { children: jsx(MenuItem, __assign({ onClick: handleMenuClose(handleImportClicked) }, { children: "Import" }), void 0) }), void 0)),
                                                        (archiveMutation || recoverMutation) && (jsxs(AuthenticatedComponent, __assign({ requiredPermissions: ["delete:" + permissionName] }, { children: [jsx(Divider, {}, void 0),
                                                                archiveMutation && (jsx(MenuItem, __assign({ onClick: handleMenuClose(handleSetActive), disabled: !canSetActive() }, { children: "Make Active" }), void 0)),
                                                                recoverMutation && (jsx(MenuItem, __assign({ onClick: handleMenuClose(handleSetInactive), disabled: !canSetInactive() }, { children: "Make Inactive" }), void 0))] }), void 0))] }, void 0)), renderAdditionalMenuItems()] }), void 0)] }, void 0) }), void 0)),
                            showSearch && (jsx("div", { children: jsx(StandardSearchInput, { searchText: searchText, handleSearchChange: handleSearchChange, isLoading: isFetching }, void 0) }, void 0)), afterActionItemsSlot] }), void 0)] }), void 0)), breadCrumbs && renderSubtitleSection(), jsx(Grid, __assign({ item: true }, { children: jsx(PaginatedDataTable, { columns: tableColumns, loading: isLoading || isFetching, queryResults: data, defaultSortKey: (_a = defaultPaginationProps.sortKey) !== null && _a !== void 0 ? _a : '', defaultSortDesc: !defaultPaginationProps.sortAsc, setPagination: setPaginatedProps, selectedRecords: selectedRows, setSelectedRecords: isRowSelectionEnabled ? setSelectedRows : undefined, editPermissions: { requiredPermissions: ["edit:" + permissionName] }, onEdit: handleEdit, onRowClick: handleRowClick, isPaginationVisible: isPaginationVisible, isBorderVisible: isBorderVisible, editIcon: editIcon, editToolTip: editToolTip, referenceNumberColumnKeySuffixes: referenceNumberColumnKeySuffixes }, void 0) }), void 0)] }), void 0));
};

var StandardReadOnlyListView = function (props) {
    var _a;
    var defaultPaginationProps = props.defaultPaginationProps, tableColumns = props.tableColumns, tableColumnGroups = props.tableColumnGroups, getDataQuery = props.getDataQuery, entityNamePlural = props.entityNamePlural, handleRowClick = props.handleRowClick, headerTitle = props.headerTitle, headerIcon = props.headerIcon, hideSearch = props.hideSearch, hideFilterButton = props.hideFilterButton, breadCrumbs = props.breadCrumbs, _b = props.additionalQueryParameters, additionalQueryParameters = _b === void 0 ? {} : _b, _c = props.isHeaderVisible, isHeaderVisible = _c === void 0 ? true : _c, _d = props.isPaginationVisible, isPaginationVisible = _d === void 0 ? true : _d, _e = props.isBorderVisible, isBorderVisible = _e === void 0 ? true : _e, handleFilterClicked = props.handleFilterClicked, _f = props.filterChips, filterChips = _f === void 0 ? [] : _f, handleFilterChipDelete = props.handleFilterChipDelete, additionalHeaderElements = props.additionalHeaderElements, _g = props.showCompactToggle, showCompactToggle = _g === void 0 ? false : _g, _h = props.customRowStyling, customRowStyling = _h === void 0 ? function (row) {
        return {};
    } : _h, _j = props.headerVariant, headerVariant = _j === void 0 ? 'h1' : _j, _k = props.isTableHeaderVisible, isTableHeaderVisible = _k === void 0 ? true : _k, _l = props.subtitleComponentSlot, subtitleComponentSlot = _l === void 0 ? null : _l, _m = props.headerAlignment, headerAlignment = _m === void 0 ? 'start' : _m, referenceNumberColumnKeySuffixes = props.referenceNumberColumnKeySuffixes;
    var _o = useState(''), searchText = _o[0], setSearchText = _o[1];
    var _p = useState(false), isDenseView = _p[0], setIsDenseView = _p[1];
    var _q = useState(defaultPaginationProps), paginatedProps = _q[0], setPaginatedProps = _q[1];
    var _r = getDataQuery(__assign({ searchText: searchText, sortKey: paginatedProps === null || paginatedProps === void 0 ? void 0 : paginatedProps.sortKey, sortAsc: paginatedProps === null || paginatedProps === void 0 ? void 0 : paginatedProps.sortAsc, page: paginatedProps === null || paginatedProps === void 0 ? void 0 : paginatedProps.page, pageSize: paginatedProps === null || paginatedProps === void 0 ? void 0 : paginatedProps.pageSize, includeInactive: false }, additionalQueryParameters)), data = _r.data, isLoading = _r.isLoading, error = _r.error, refetch = _r.refetch, isFetching = _r.isFetching;
    var handleSearchChange = function (newText) {
        setSearchText(newText);
    };
    var handleDenseToggleChange = function (event) {
        setIsDenseView(event.target.checked);
    };
    if (isLoading) {
        return jsx(LoadingIndicator, {}, void 0);
    }
    if (error) {
        return jsx(ApiError, { onReloadClick: refetch }, void 0);
    }
    return (jsxs(Grid, __assign({ container: true, direction: 'column' }, { children: [isHeaderVisible && (jsxs(Grid, __assign({ item: true, container: true, direction: 'row', alignItems: headerAlignment, pb: 2 }, { children: [jsxs(Grid, __assign({ item: true, container: true, direction: 'column', justifyContent: headerAlignment, xs: 4 }, { children: [(headerIcon || headerTitle) && (jsxs(Typography, __assign({ variant: headerVariant, sx: { marginBottom: '8px' } }, { children: [headerIcon, " ", headerTitle] }), void 0)), !breadCrumbs && subtitleComponentSlot, breadCrumbs && jsx(NavBreadcrumbs, { links: breadCrumbs, currentPageLabel: entityNamePlural }, void 0)] }), void 0),
                    jsxs(Grid, __assign({ item: true, display: 'flex', justifyContent: 'end', gap: 2, xs: 8 }, { children: [additionalHeaderElements, showCompactToggle && (jsx(FormControlLabel, { control: jsx(Switch, { checked: isDenseView, onChange: handleDenseToggleChange }, void 0), label: 'Compact', labelPlacement: 'start' }, void 0)),
                            handleFilterClicked && !hideFilterButton && (jsx(Tooltip, __assign({ title: 'Filter' }, { children: jsx("span", { children: jsx(IconButton, __assign({ size: 'large', onClick: handleFilterClicked, color: 'primary' }, { children: jsx(FilterList, { fontSize: 'inherit' }, void 0) }), void 0) }, void 0) }), void 0)),
                            !hideSearch && (jsx("div", { children: jsx(StandardSearchInput, { searchText: searchText, handleSearchChange: handleSearchChange, isLoading: isFetching }, void 0) }, void 0))] }), void 0)] }), void 0)),
            breadCrumbs && subtitleComponentSlot && (jsx(Grid, __assign({ item: true }, { children: subtitleComponentSlot }), void 0)),
            filterChips.length > 0 && (jsx(Grid, __assign({ item: true, display: 'flex', flexWrap: 'wrap', gap: 1, pb: 2 }, { children: filterChips.map(function (filterChip) {
                    var _a;
                    return (jsx(Chip, { label: "" + filterChip.key + ((_a = filterChip.separator) !== null && _a !== void 0 ? _a : ':') + " " + filterChip.text, color: 'primary', onDelete: handleFilterChipDelete ? function () { return handleFilterChipDelete(filterChip.key); } : undefined }, filterChip.key));
                }) }), void 0)),
            jsx(Grid, __assign({ item: true, sx: { maxWidth: '100% !important' } }, { children: jsx(PaginatedDataTable, { columns: tableColumns, columnGroups: tableColumnGroups, loading: isLoading || isFetching, queryResults: data, defaultSortKey: (_a = defaultPaginationProps.sortKey) !== null && _a !== void 0 ? _a : '', defaultSortDesc: !defaultPaginationProps.sortAsc, setPagination: setPaginatedProps, onRowClick: handleRowClick, isPaginationVisible: isPaginationVisible, isBorderVisible: isBorderVisible, isDense: isDenseView, customRowStyling: customRowStyling, isHeaderVisible: isTableHeaderVisible, referenceNumberColumnKeySuffixes: referenceNumberColumnKeySuffixes }, void 0) }), void 0)] }), void 0));
};

var LocalDataTable = function (props) {
    var columns = props.columns, rowData = props.rowData, loading = props.loading, height = props.height, tableFooter = props.tableFooter, dense = props.dense;
    var _a = useState(''), hoverRow = _a[0], setHoverRow = _a[1];
    var handleRowOnMouseEnter = function (id) {
        setHoverRow(id);
    };
    var handleRowOnMouseLeave = function (id) {
        if (hoverRow === id)
            setHoverRow('');
    };
    var renderHeaders = function (headers) {
        return headers.map(function (header) {
            return (jsx(TableCell, __assign({ align: header.align }, { children: header.label }), header.key));
        });
    };
    var renderFields = function (row, headers) {
        return headers.map(function (header) {
            var field = null;
            if (header.fieldMapper) {
                field = header.fieldMapper(row);
            }
            else {
                var accessors = header.key.split('.');
                field = row;
                accessors.forEach(function (key) { return (field = field[key]); });
            }
            return (jsx(TableCell, __assign({ align: header.align, color: header.color, sx: { py: dense ? 1 : 2 } }, { children: field }), header.key));
        });
    };
    return (jsx(Paper, __assign({ elevation: 0, sx: { border: 'solid 1px #AAAAAA' } }, { children: jsx(TableContainer, __assign({ sx: { height: height } }, { children: jsxs(Table, __assign({ stickyHeader: true, sx: { height: 'max-content' } }, { children: [jsx(TableHead, { children: jsx(TableRow, { children: renderHeaders(columns) }, void 0) }, void 0),
                    jsxs(TableBody, { children: [rowData && rowData.length > 0
                                ? rowData.map(function (row, index) {
                                    return (jsx(TableRow, __assign({ hover: true, onMouseEnter: function () { return handleRowOnMouseEnter(row.id); }, onMouseLeave: function () { return handleRowOnMouseLeave(row.id); }, tabIndex: -1 }, { children: renderFields(row, columns) }), index + "-row-" + row.id));
                                })
                                : !loading && (jsx(TableRow, { children: jsx(TableCell, __assign({ align: 'center', colSpan: columns.length + 1 }, { children: "No results found." }), void 0) }, void 0)),
                            loading && (jsx(TableRow, { children: jsx(TableCell, __assign({ align: 'center', colSpan: columns.length + 1 }, { children: jsx(LoadingIndicator, {}, void 0) }), void 0) }, void 0))] }, void 0),
                    tableFooter ? tableFooter : jsx(Fragment, {}, void 0)] }), void 0) }), void 0) }), void 0));
};

var NotAuthorizedError = function (props) {
    return (jsxs(Grid, __assign({ container: true, direction: 'column', alignItems: 'center' }, { children: [jsx(Grid, __assign({ item: true }, { children: jsx(Typography, __assign({ fontWeight: 'bold', fontSize: 24 }, { children: "Oops... something went wrong" }), void 0) }), void 0),
            jsx(Grid, __assign({ item: true }, { children: jsx(Typography, { children: "You've attempted to do something that you do not have access to." }, void 0) }), void 0)] }), void 0));
};

var PermissionToggler = function (props) {
    var getPermissionsQuery = props.getPermissionsQuery;
    var _a = useState(false), isOpen = _a[0], setIsOpen = _a[1];
    var _b = useContext(UserPermissionContext), permissions = _b.permissions, togglePermission = _b.togglePermission;
    var _c = getPermissionsQuery(), getAllPermissions = _c[0], _d = _c[1], allPermissions = _d.data, isLoading = _d.isLoading, isError = _d.isError, fulfilledTimeStamp = _d.fulfilledTimeStamp;
    useFailedActionSnackbar('retrieving', 'permissions', isError);
    useEffect(function () {
        if (isOpen && !fulfilledTimeStamp) {
            getAllPermissions();
        }
    }, [isOpen, fulfilledTimeStamp, getAllPermissions]);
    var renderPermissionSections = function () {
        if (!allPermissions) {
            return null;
        }
        var constAllSectionNames = Array.from(new Set(allPermissions.map(function (p) { return p.split(':')[1]; }))).sort(function (a, b) { return a.localeCompare(b); });
        return constAllSectionNames.map(function (sectionName) {
            var sectionPermissions = allPermissions
                .filter(function (p) { return p.endsWith(sectionName); })
                .map(function (p) { return p.split(':')[0]; })
                .sort(function (a, b) { return a.localeCompare(b); });
            return (jsxs(Grid, __assign({ container: true, item: true, direction: 'column' }, { children: [jsx(Grid, __assign({ item: true }, { children: jsx(Typography, __assign({ fontWeight: 'bold' }, { children: sectionName }), void 0) }), void 0),
                    jsx(Grid, __assign({ container: true, item: true, direction: 'row' }, { children: sectionPermissions.map(function (sectionPermission) { return (jsx(Grid, __assign({ item: true, xs: 6, sm: 4, md: 3 }, { children: jsx(FormControlLabel, { control: jsx(Checkbox, { checked: permissions.includes(sectionPermission + ":" + sectionName), onClick: function () { return togglePermission(sectionPermission + ":" + sectionName); } }, void 0), label: sectionPermission }, void 0) }), "permission-" + sectionName + "-" + sectionPermission)); }) }), void 0)] }), "permission-section-" + sectionName));
        });
    };
    if (isOpen) {
        return (jsx(Card, __assign({ sx: { width: '600px', position: 'absolute', right: '8px', bottom: '8px' } }, { children: jsxs(CardContent, { children: [jsx(Typography, __assign({ fontWeight: 'bold', gutterBottom: true }, { children: "Permission Toggler" }), void 0),
                    jsx(IconButton, __assign({ onClick: function () { return setIsOpen(false); }, style: { position: 'absolute', top: '8px', right: '8px' } }, { children: jsx(Close, {}, void 0) }), void 0),
                    jsxs(Grid, __assign({ container: true, sx: { maxHeight: '400px', overflowY: 'auto' } }, { children: [isLoading && jsx(LoadingIndicator, {}, void 0), renderPermissionSections()] }), void 0)] }, void 0) }), void 0));
    }
    else {
        return (jsxs(Fab, __assign({ color: 'primary', size: 'small', variant: 'extended', sx: { position: 'fixed', right: '8px', bottom: '8px' }, onClick: function () { return setIsOpen(true); } }, { children: [jsx(AutoAwesome, { sx: { mr: 1 } }, void 0), "Toggle Permissions"] }), void 0));
    }
};

var StandardFormDialog = function (props) {
    var defaultOnResetMethod = function () {
        console.warn('No reset method defined. Save was executed but no form values will change');
    };
    var icon = props.icon, title = props.title, entityName = props.entityName, onSave = props.onSave, onClose = props.onClose, _a = props.onReset, onReset = _a === void 0 ? defaultOnResetMethod : _a, _b = props.isLoading, isLoading = _b === void 0 ? false : _b, _c = props.isFormDirty, isFormDirty = _c === void 0 ? false : _c, _d = props.isKeepOpenToggleVisible, isKeepOpenToggleVisible = _d === void 0 ? true : _d;
    var _e = useState(false), isKeepOpenEnabled = _e[0], setIsKeepOpenEnabled = _e[1];
    var defaultDialogProps = {
        maxWidth: 'md',
        fullWidth: true,
    };
    var handleSave = function () { return __awaiter(void 0, void 0, void 0, function () {
        var isSaveSuccessful;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, onSave()];
                case 1:
                    isSaveSuccessful = _a.sent();
                    if (!isSaveSuccessful) {
                        return [2 /*return*/];
                    }
                    onReset();
                    if (!isKeepOpenEnabled) {
                        onClose();
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleClose = function () {
        setIsKeepOpenEnabled(false);
        onClose();
    };
    var renderDialogBody = function () {
        return props.children;
    };
    return (jsxs(Dialog, __assign({}, __assign(__assign({}, defaultDialogProps), props.dialogProps), { children: [jsx(DialogTitle, { children: jsxs(Grid, __assign({ container: true, direction: 'row', justifyContent: 'space-between' }, { children: [jsx(Grid, __assign({ item: true }, { children: jsxs(Typography, __assign({ variant: 'h2' }, { children: [icon, title] }), void 0) }), void 0),
                        jsx(Grid, __assign({ item: true }, { children: isLoading && jsx(CircularProgress, { color: 'inherit', size: 18, thickness: 8 }, void 0) }), void 0)] }), void 0) }, void 0),
            jsx(DialogContent, __assign({ sx: { marginY: 2 } }, { children: renderDialogBody() }), void 0),
            jsx(DialogActions, { children: jsxs(Grid, __assign({ container: true, direction: 'row', spacing: 2 }, { children: [isKeepOpenToggleVisible && (jsxs(Grid, __assign({ item: true }, { children: [jsx(Switch, { value: isKeepOpenEnabled, onChange: function (_, isChecked) { return setIsKeepOpenEnabled(isChecked); } }, void 0), " Add new ", entityName, " after save"] }), void 0)),
                        jsx(Grid, { item: true, style: { flexGrow: '1' } }, void 0),
                        jsx(Grid, __assign({ item: true }, { children: jsx(Button, __assign({ variant: 'outlined', onClick: handleClose }, { children: isFormDirty ? 'CANCEL' : 'CLOSE' }), void 0) }), void 0),
                        jsx(Grid, __assign({ item: true }, { children: jsx(Button, __assign({ variant: 'contained', onClick: handleSave, disabled: isLoading }, { children: "SAVE" }), void 0) }), void 0)] }), void 0) }, void 0)] }), void 0));
};

var UserAvatar = function (props) {
    var name = props.name, isSecondary = props.isSecondary;
    var theme = useTheme();
    var getInitials = function () {
        if (name) {
            var nameParts = name.split(/[\s]+/);
            if (nameParts.length >= 2) {
                return "" + nameParts[0][0] + nameParts[1][0];
            }
            else if (nameParts.length === 1) {
                if (nameParts[0].length > 1) {
                    return "" + nameParts[0][0] + nameParts[0][1];
                }
                else {
                    return nameParts[0][0];
                }
            }
        }
        return '?';
    };
    return (jsx(Avatar, __assign({ sx: {
            background: isSecondary ? theme.palette.secondary.main : theme.palette.primary.main,
            height: '40px',
            width: '40px',
        } }, { children: jsx("div", { children: getInitials().toUpperCase() }, void 0) }), void 0));
};

export { ApiError, AuthenticatedComponent, BasicTransferList, CardListView, ConfirmationModalWrapper, Currency, Decimal, FormInput, FormNumberInput, FormSection, Hour, IEntityAutocomplete, IEntitySelect, Inches, LoadingBackdrop, LoadingIndicator, LocalDataTable, Minute, MobileListView, NavBreadcrumbs, NotAuthorizedError, PaginatedDataTable, PaginationActions, PermissionToggler, SlimFormHeader, SlimPageHeader, StandardCardWithHeader, StandardDialogHeader, StandardFormDialog, StandardIsActiveToggle, StandardListView, StandardListViewV2, StandardReadOnlyListView, StandardSearchInput, TransferListColumn, TransferListItem, UserAvatar, UserPermissionContext, Year, areObjectsDifferent, areObjectsEqual, checkForCustomErrorMessage, createValidatorConfig, isAlphanumericLowercase, isAlphanumericUppercase, isGreaterThanOrEqualTo, isLowercase, isNotBlank, isOnlyNumbers, isShorterThanMaxLength, isUppercase, isValidEmail, isValidURL, runFieldValidation, runFormValidation, useActivateInactivateSnackbar, useBulkActionSnackbar, useFailedActionSnackbar, useFailedCreateSnackbar, useFailedUpdateSnackbar, useStandardSnackbar, useStandardValidatedFormManager, useSuccessfulActionSnackbar, useSuccessfulCreateSnackbar, useSuccessfulUpdateSnackbar, userHasAllPermissions, userHasAnyPermissions, userHasPermissions };
